export default {
  notif: { title: "Билдиришномалар", subtitle: "Ким, қачон, нима қилди", markAll: "Ҳаммасини ўқилди", empty: "Билдиришнома йўқ", seeAll: "Ҳаммасини кўриш", loadError: "Юклашда хато" },
  common: { selectPlaceholder: "Танланг...", searchPlaceholder: "Қидириш...", noResults: "Ҳеч нима топилмади" },
  proc: {
    title: "Менинг жараёнларим", subtitle: "Бажариш керак бўлган жараёнлар",
    empty: "Жараён йўқ", emptyHint: "Сизга бириктирилган жараёнлар шу ерда чиқади", filesTitle: "Эскиз / файллар", archiveTitle: "Архив", backToWork: "Ишларга қайтиш", archiveEmpty: "Архив бўш", archiveEmptyHint: "Тугатилган ишларингиз шу ерда сақланади", proposalTag: "Таклиф", tabWork: "Ишларим", tabRequests: "Пул сўрови", tabArchive: "Архив",
    countSuffix: "та жараён", logout: "Чиқиш", refresh: "Янгилаш",
    saved: "Сақланди", loadError: "Юклашда хато",
    problemTitle: "Муаммо нима?", problemPlaceholder: "Муаммони қисқача ёзинг…", problemSubmit: "Юбориш", problemRequired: "Муаммо тавсифини киритинг", cancel: "Бекор қилиш",
  },

  snab: {
    title: "Менинг заявкаларим", subtitle: "Олиб келиш керак бўлган ҳужжатлар",
    createReceipt: "Кирим яратиш", tabProducts: "Маҳсулотлар", tabSuppliers: "Таъминотчилар", suppliersEmpty: "Таъминотчилар йўқ", needQty: "Керак", buy: "Сотиб олиш", zoom: "Катталаштириш", tabRequests: "Пул сўрови", needBy: "Муддат:", noItems: "Позициялар йўқ",
    logout: "Чиқиш", refresh: "Янгилаш", loadError: "Юклашда хато",
  },

  roles: {
    title: "Роллар", subtitle: "Махсус роллар — модул кўриниши, амаллар ва маълумотларни бошқариш",
    addRole: "Рол қўшиш", editRole: "Ролни таҳрирлаш", name: "Рол номи", namePlaceholder: "Масалан: Сотувчи, Омборчи...", nameRequired: "Рол номи киритилиши шарт",
    modulesSection: "Модуллар ва амаллар", module: "Модул", actionView: "Кўр", actionCreate: "Қўш", actionEdit: "Таҳр", actionDelete: "Ўч",
    dataFlagsSection: "Яшириладиган маълумотлар", dataFlagsHint: "Белгиланган маълумотлар бу рол учун яширилади (телефон, email, битим суммаси...)",
    ownSection: "Фақат ўзиникини кўрсатиш", ownHint: "Белгиланган бўлимларда фойдаланувчи фақат ўзи яратган ҳужжатларни кўради (бошқаларникини эмас).",
    save: "Сақлаш", cancel: "Бекор", delete: "Ўчириш", deleteTitle: "Ролни ўчириш", deleteText: "роли ўчирилади. Бу ролдаги фойдаланувчилар тўлиқ ҳуқуққа қайтади.",
    added: "Рол қўшилди", updated: "Рол янгиланди", deleted: "Рол ўчирилди", loadError: "Юклашда хато", genericError: "Хато юз берди",
    empty: "Роллар йўқ", modulesCount: "модул", hiddenCount: "яширин",
    restricted: "Бу маълумот сизга кўринмайди",
    prodSubActionsLabel: "Ишлаб чиқариш: алоҳида киритиш ҳуқуқлари",
    prodEditOutputs: "Тайёр маҳсулот партияси киритиш",
    prodEditComponents: "Хомашё сарфи киритиш",
    flags: {
      contacts_phone: "Контакт телефон рақами", contacts_email: "Контакт email", deals_value: "Битим (сделка) суммаси",
      products_costPrice: "Таннарх (харид нархи)", products_avgCost: "Ўртача таннарх", products_margin: "Маржа / устама", inventory_stockValue: "Қолдиқ қиймати",
      sklad_valuation: "Склад қиймати (жами таннарх)", sklad_unitCost: "Бирлик таннархи",
      finance_pnl: "Фойда ва зарар (P&L)", finance_companyBalance: "Корхона баланси", finance_cashboxBalance: "Касса баланслари", finance_netProfit: "Соф фойда", finance_cogs: "Таннарх (COGS)", finance_debtsTotals: "Қарз суммалари",
      cashbox_balance: "Касса баланси", cashbox_turnover: "Касса айланмаси",
      jobOrder_summary: "Заказ суммалари (статистика + келишилган/тўланган/қарз)", jobOrder_profit: "Заказ фойдаси", jobOrder_totalCost: "Заказ таннархи", jobOrder_laborCost: "Иш ҳақи харажати", jobOrder_materialCost: "Материал харажати",
      jobOrder_lockBasic: "Асосий маълумотларни ўзгартиришни тақиқлаш", jobOrder_lockProcesses: "Жараёнларни ўзгартиришни тақиқлаш", jobOrder_lockMaterials: "Расходларни ўзгартиришни тақиқлаш", jobOrder_lockFiles: "Файлларни ўзгартиришни тақиқлаш", jobOrder_lockDelete: "Заказни ўчиришни тақиқлаш",
      jobOrder_otherExpenses: "Бошқа харажатлар бўлимини яшириш", jobOrder_otherExpensesEdit: "Бошқа харажат қўшишни тақиқлаш", jobOrder_otherExpensesDelete: "Бошқа харажатни ўчиришни тақиқлаш",
      jobOrder_lockConfirm: "Заказни тасдиқлашни тақиқлаш", jobOrder_lockStart: "Жараёнга ўтказишни тақиқлаш", jobOrder_lockComplete: "Заказни якунлашни тақиқлаш",
      proposal_cost: "Таклиф таннархи", proposal_margin: "Таклиф маржаси",
      reports_inventoryValue: "Ҳисобот: омбор қиймати", reports_profitColumns: "Ҳисобот: фойда устунлари",
    },
  },

  dtp: { now: "Ҳозир", done: "Тайёр" },
  picker: { placeholder: "Маҳсулот...", search: "Қидириш...", notFound: "Топилмади" },
  catPicker: { all: "Барчаси", back: "Орқага", empty: "Бўш", count: "{n} та" },
  update: { title: "Янги версия мавжуд", subtitle: "Янгилаб олинг", action: "Янгилаш", dismiss: "Ёпиш" },


  production: {
    loadError: "Юклашда хато", error: "Хато", cancel: "Бекор", save: "Сақлаш", saved: "Янгиланди", added: "Қўшилди", deleted: "Ўчирилди", movedToTrash: "Корзинага ўтказилди", toTrash: "Корзинага", delete: "Ўчириш", back: "Орқага", selectPlaceholder: "Танланг...", row: "Қатор", addRow: "Қатор қўшиш", print: "Чоп", printTitle: "Чоп этиш", unitSuffix: "дона",
    prodLabel: "Ишлаб чиқариш", prodSubtitle: "Хомашёдан тайёр маҳсулот", pkgLabel: "Упаковка", pkgSubtitle: "Тайёр маҳсулотни қадоқлаш",
    searchPlaceholder: "Рақам ёки маҳсулот...", new: "Янги", notFound: "Ҳужжат топилмади", notFoundHint: "Янги ҳужжат яратинг", newBlank: "Бўш яратиш", newFromRecipe: "Рецепт асосида", recipe: "Рецепт", norma: "Норма (неча марта)", normaHint: "Рецепт шу сонга кўпайтирилади (1 норма = 1 рецепт) — хомашё ва чиқиш шунга қараб ёзилади.", noRecipes: "Рецептлар йўқ. Аввал Рецептлар (BOM) бўлимидан қўшинг.", recipePickFirst: "Рецептни танланг",
    thNumber: "Рақам", thDate: "Сана", thOutput: "Тайёр маҳсулот", thOut: "Чиқди", thCost: "Таннарх", thUnit: "Бирлик", thStatus: "Ҳолат", thActions: "Амаллар", outLabel: "Чиқди:",
    trashTitle: "Корзинага ўтказиш", trashText1: "ҳужжати корзинага ўтказилади. Хомашё қолдиғи ва тайёр маҳсулот қолдиғи қайтарилади (30 кун ичида тиклаш мумкин).",
    docLoadError: "Ҳужжат юкланмади", bomSelectProductFirst: "Аввал тайёр маҳсулотни танланг", bomQtyFirst: "Чиқиш миқдорини киритинг", bomNotFound: "Бу маҳсулот учун рецепт топилмади", bomLoaded: "Рецепт юкланди", whRequired: "Омборлар танланиши шарт", outProductRequired: "Тайёр маҳсулот танланиши шарт", outQtyInvalid: "Чиқиш миқдори нотўғри", minOneComponent: "Камида битта хомашё киритинг", costShare: "Таннарх улуши", costShareAuto: "авто", costShareHint: "Улуш бўш қолдирилса — умумий таннарх чиқиш миқдорига қараб автоматик тақсимланади. Улуш киритсангиз — шу вазнлар нисбатида.", outAllocCost: "Таннарх", outputsCount: "маҳсулот", removeRow: "Қаторни ўчириш", lotLabel: "Партия:", lotCol: "Партия", lotAuto: "Авто (энг эски)", lotNoLabel: "Партиясиз", lotLeft: "қолдиқ", uomRequired: "Ўлчов бирлигини танланг", compProductRequired: "Хомашё маҳсулотини танланг", compQtyRequired: "Хомашё миқдорини киритинг", addGroup: "Гуруҳ", newGroup: "Янги гуруҳ", groupNamePlaceholder: "Гуруҳ номи", removeGroup: "Гуруҳни ўчириш", moveTo: "Кўчириш", moveToUngrouped: "Гуруҳсизга",
    fromWh: "Хомашё омбори (қайердан)", toWh: "Тайёр омбор (қайерга)", outputCard: "Тайёр маҳсулот", applyBomTitle: "Танланган маҳсулот рецептидан хомашёларни юклаш", applyBom: "Рецептдан юклаш", product: "Маҳсулот", outProductPlaceholder: "Тайёр маҳсулот...", qty: "Миқдор", uom: "Бирлик", uomPlaceholder: "дона, кг...", batchNo: "Партия №", batchPlaceholder: "(ихтиёрий)", expiry: "Яроқлилик муддати", addBatch: "Партия қўшиш", batchTime: "Вақт", batchTotal: "Жами", grandTotalLabel: "Умумий тайёр маҳсулот:", normaTitle: "Норма", normaPerUnit: "учун хомашё", normaAdd: "Хомашё қўшиш",
    componentsTitle: "Хомашёлар (расход)", noComponents: "Хомашё қаторлари йўқ", colProduct: "Маҳсулот", colQty: "Миқдор", colUom: "Бирлик", colEstCost: "Тахм. таннарх", uomPlaceholder2: "бирлик", costInline: "Таннарх:", stockInStock: "Склад:",
    overheadTitle: "Қўшимча харажат (ихтиёрий)", noOverhead: "Қаторлар йўқ (иш ҳақи, электр, амортизация ва ҳ.к.)", colCategory: "Категория (кассадан)", colName: "Номи", colAmount: "Сумма", catManual: "— (қўлда)", overheadNamePlaceholder: "Иш ҳақи, Электр...", amountPlaceholder: "Сумма", overheadHint: "Категория танласангиз, Тўловлардаги чиқим категориясига боғланади (ҳисоботларда бирлаштирилган кўринади). Категорияни Молия → Тўловлар бўлимидан яратасиз.", colCashbox: "Касса (нақд)", overheadNoCash: "— (фақат таннархга)", overheadCashHint: "Касса танланса — бу харажат шу кассадан нақд чиқим бўлади ва касса картасида кўринади. Таннархга барибир қўшилади; Тўловлар/P&L'га алоҳида ёзилмайди (икки марта санаш йўқ).",
    costTitle: "Таннарх (тахминий)", costMaterials: "Хомашёлар", costOverhead: "Қўшимча харажат", costTotal: "Жами таннарх", costUnit: "Бирлик таннарх", costNote: "Сақлаганда ҳақиқий таннарх FIFO/ўртача усули билан аниқланади ва тайёр маҳсулот avgCost'и шу асосда янгиланади.", note: "Изоҳ", optional: "Ихтиёрий...",
    trashText2: "Ҳужжат корзинага ўтказилади. Хомашё қолдиғи ва тайёр маҳсулот қолдиғи қайтарилади (30 кун ичида тиклаш мумкин).",
    bomMahsulotRequired: "Маҳсулот танланиши шарт", bomMinOneComponent: "Камида битта таркиб қатори", bomOutQtyInvalid: "Чиқиш миқдори нотўғри", bomEditTitle: "Рецептни таҳрирлаш", bomNewTitle: "Янги рецепт (BOM)", bomKind: "Тур", bomOutProduct: "Тайёр маҳсулот", bomOutQty: "Чиқиш миқдори", bomOutQtyHint: "Ушбу рецепт шу сондаги тайёр маҳсулот учун", bomUom: "Бирлик", bomComponents: "Хомашёлар", bomNoRows: "Қаторлар йўқ", bomColUom: "Бирлик", bomColNote: "Изоҳ", bomColCategory: "Категория", bomOverheadHint: "Категория танласангиз, Тўловлардаги чиқим категориясига боғланади (ҳисоботларда бирлаштирилган кўринади).",
    bomTitle: "Рецептлар (BOM)", bomNavShort: "Рецептлар", recipeSaveBtn: "Рецепт сақлаш", recipeSaveTitle: "Жорий формани рецепт қилиб сақлаш", recipeSaveHint: "Ҳозирги тайёр маҳсулот, хомашё ва харажатлар рецепт бўлиб сақланади. Кейин 'Рецепт асосида' + норма билан шу маълумотлар автоматик тўлади.", recipeName: "Рецепт номи", recipeNamePlaceholder: "Масалан: Нон (стандарт)", recipeNameRequired: "Рецепт номини киритинг", recipeSaved: "Рецепт сақланди", bomSubtitle: "Тайёр маҳсулот учун хомашё рецептлари", all: "Ҳаммаси", bomSearchPlaceholder: "Маҳсулот...", bomNewBtn: "Рецепт", bomEmpty: "Рецептлар йўқ", bomThProduct: "Маҳсулот", bomThKind: "Тур", bomThOut: "Чиқди", bomThComposition: "Таркиб", bomThOverhead: "Қўш.хар.", componentsCount: "та хомашё", overheadShort: "Қўш.хар.:", bomDeleteTitle: "Рецептни ўчириш", bomDeleteText: "рецепти бутунлай ўчирилади.",
    ppProdTitle: "ИШЛАБ ЧИҚАРИШ ҲУЖЖАТИ", ppPkgTitle: "УПАКОВКА ҲУЖЖАТИ", ppDate: "Сана:", ppRawWh: "Хомашё омбори:", ppFinishedWh: "Тайёр маҳсулот омбори:", ppFinished: "Тайёр маҳсулот:", ppBatch: "Партия №:", ppExpiry: "Яроқлилик:", ppComponents: "Хомашёлар", ppColNum: "№", ppColName: "Номи", ppColQty: "Миқдор", ppColUom: "Ўлчов", ppColUnitCost: "Бирлик таннарх", ppColSum: "Сумма", ppMaterialsTotal: "Хомашёлар жами:", ppOverhead: "Қўшимча харажат", ppOverheadTotal: "Қўшимча жами:", ppTotalCost: "Жами таннарх:", ppUnitCost: "Бирлик таннарх:", ppNote: "Изоҳ:", ppSignMaker: "Ишлаб чиқарувчи (имзо)", ppSignReceiver: "Қабул қилди (имзо)",
  },

  scheduled: {
    title: "Мажбурий тўловлар", subtitle: "Ҳар ой муайян кунда тўланадиган тўловлар шаблони.",
    new: "Янги тўлов", add: "Қўшиш", edit: "Таҳрирлаш", delete: "Ўчириш",
    name: "Номи", namePlaceholder: "Офис ижараси, Электр тўлови...",
    amount: "Сумма", dayOfMonth: "Ойнинг неча-си", dayHint: "(1–28)",
    cashbox: "Касса", category: "Категория", counterparty: "Контрагент", note: "Изоҳ",
    optional: "ихтиёрий",
    statusPaid: "Тўланди", statusPending: "Кутилмоқда", statusOverdue: "Кечикган",
    lastPaid: "Охирги тўлов",
    payBtn: "Чиқим яратиш", payTitle: "Тўлов яратиш", payDate: "Сана", payConfirm: "Тўлов яратиш",
    paySuccess: "Тўлов яратилди", payError: "Хатолик юз берди",
    deleteConfirm: "Шаблон ўчирилсинми?", deleted: "Ўчирилди",
    saved: "Сақланди", loadError: "Юклаб бўлмади",
    empty: "Мажбурий тўловлар йўқ", emptyHint: "Ҳар ой тўланадиган харажатларни қўшинг",
    active: "Фаол", inactive: "Нофаол", toggleActive: "Ҳолатни ўзгартириш",
    every: "Ҳар ойнинг", dayLabel: "-си",
    totalMonth: "Жами мажбурий тўлов", totalPaid: "Тўланди", totalRemain: "Қолди",
    itemsCount: "та",
  },
  payReq: {
    title: "Сўровлар", subtitle: "Ходимларнинг пул сўровлари (заявкалар).", new: "Сўров", newTitle: "Янги сўров",
    send: "Юбориш", sent: "Сўров юборилди", cancel: "Бекор", amount: "Сумма", amountInvalid: "Сумма нотўғри",
    note: "Изоҳ", notePlaceholder: "Нима учун керак...", paymentMethod: "Тўлов шакли", paymentMethodPlaceholder: "Нақд / Карта / Перечисления...", pmCash: "Нақд", pmCard: "Карта", pmTransfer: "Перечисления", jobOrder: "Заказ", optional: "ихтиёрий", searchPlaceholder: "Рақам ёки мижоз...", notFound: "Топилмади", noteRequired: "Изоҳ киритилиши шарт",
    loadError: "Юклашда хатолик", error: "Хатолик", empty: "Сўров йўқ", emptyHint: "Янги сўров қўшинг",
    byFinance: "Молия:", reason: "Сабаб:", approve: "Тасдиқлаш", approved: "Тасдиқланди", markPaid: "Тўланди", approveTitle: "Сўровни тасдиқлаш", approveHint: "Рухсат бериладиган суммани киритинг. Бу ҳали тўлов эмас.", approvedAmount: "Тасдиқланган сумма", requested: "Сўралган", statTotal: "Жами сўровлар", statApproved: "Тасдиқланган", statPaid: "Берилган", statRejected: "Рад этилган", reject: "Рад этиш",
    rejectTitle: "Сўровни рад этиш", rejectReasonLabel: "Рад этиш сабаби (ихтиёрий):", rejectReasonPlaceholder: "Сабаб...",
    rejected: "Рад этилди", delete: "Ўчириш", deleteConfirm: "Сўров ўчирилсинми?", deleted: "Ўчирилди",
    tabs: { pending: "Кутилмоқда", approved: "Тасдиқланган", paid: "Тўланган", rejected: "Рад этилган", all: "Ҳаммаси" },
    status: { pending: "Кутилмоқда", approved: "Тасдиқланган", paid: "Тўланган", rejected: "Рад этилган" },
  },
  integrations: { back: "Орқага",
    title: "Интеграциялар", subtitle: "Бошқа сервислар билан интеграцияларни ёқинг.",
    saved: "Сақланди", error: "Хатолик", on: "Ёқилган", enable: "Ёқиш", disable: "Ўчириш", activeSuffix: "фаол", off: "Ўчиқ", soon: "Тез орада", configure: "Созлаш", eskizConn: "Уланиш", eskizOk: "Уланган", eskizEmail: "Email", eskizPassword: "Парол", eskizPassKeep: "Ўзгартирмаслик учун бўш қолдиринг", eskizFrom: "Жўнатувчи (nick)", eskizFromHint: "Тест учун 4546. Ҳақиқий ник Eskiz'да тасдиқланади.", eskizSave: "Сақлаш ва уланиш", eskizTest: "Тест SMS", eskizPhone: "Телефон", eskizMessage: "Хабар", eskizSendTest: "Тест юбориш", eskizTestHint: "Стандарт матн «Это тест от Eskiz» тасдиқланган. Ўз матнингиз учун my.eskiz.uz → СМС → Мои тексты орқали модерациядан ўтказинг.", eskizEmailReq: "Email киритинг", eskizPhoneReq: "Телефон рақамини киритинг", eskizConnected: "Eskiz уланди", eskizSent: "SMS юборилди", smsRulesTitle: "SMS хабарномалар", smsRulesHint: "Ҳодиса содир бўлганда мижозга автоматик SMS юборилади (матн Eskiz'да тасдиқланган бўлиши шарт).", smsPlaceholders: "Ўрин алмаштирувчилар", smsTplPlaceholder: "Масалан: Ҳурматли {customer}, {number}-заказ қабул қилинди.", smsRulesSave: "Хабарномаларни сақлаш", tabSettings: "Созламалар", tabHistory: "Тарих", balTitle: "SMS баланс", balTotal: "Жами баланс", balPrice: "1 SMS нархи", balSave: "Балансни сақлаш", balLow: "Баланс кам!", balLowHint: "Баланс битта SMS нархидан кам. Янгиланг.", histEmpty: "Ҳали SMS юборилмаган", evtJoCreated: "Заказ (job order) яратилганда", evtJoDelivered: "Заказ (job order) якунланганда", evtSaleCreated: "Сотув (фактура) яратилганда", evtPayIncoming: "Тўлов қабул қилинганда",
    cat: { sms: "SMS", hr: "HR" },
    svc: { "hr-line": "Ходимларни бошқариш (HR Line)", "sms-eskiz": "SMS юбориш (eskiz.uz)", "sms-playmobile": "SMS шлюз (Play Mobile)", "hr-attendance": "Ходимлар давомати", "hr-payroll": "Иш ҳақи ҳисоб-китоби" },
  },
  finance: { total: "Жами", pfDocLoadError: "Ҳужжат юкланмади", pfCpRequired: "Контрагент танланиши шарт", pfCashboxRequired: "Касса танланиши шарт", pfAmountInvalid: "Сумма нотўғри", pfDateInvalid: "Сана нотўғри (DD/MM/YYYY HH:MM)", pfHeaderTitle: "Тўловлар", pfFromRequest: "Бу чиқим заявка асосида яратилмоқда:", pfPrint: "Чоп", pfPrintTitle: "Чоп этиш", pfAddAnother: "Яна кирим қўшиш", pfAddAnotherTitle: "Шу заказ учун яна кирим қўшиш (бошқа кассадан)", pfJoRemainTitle: "Заказда қолдиқ қарз бор", pfJoRemainHint: "Тўлов сақланди. Мижоз бошқа кассага ҳам тўлов қилмоқчи бўлса, «Яна кирим қўшиш» тугмасини босинг.", pfDateLabel: "Сана:", pfStatusless: "Статуссиз", pfCpLabel: "Контрагент *", pfNewCpTitle: "Янги контрагент қўшиш", pfCashboxLabel: "Касса *", pfCashboxSelect: "Касса танланг...", pfBalance: "Баланс:", pfAmountLabel: "Сумма *", pfCategoryLabel: "Категория", pfManage: "Бошқариш", pfCategoryless: "Категориясиз", pfJobOrder: "Заказ", pfJobOrderHint: "Танласангиз, тўлов шу заказ балансига боғланади. Бўш қолдирилса — оддий кирим.", pfProcess: "Жараён (меҳнат)", pfProcessHint: "Тўлов суммаси шу жараён меҳнатига ёзилади.", pfProcessRequired: "Жараён танланиши шарт", pfProcessCurrencyMismatch: "Тўлов валютаси заказ валютаси билан бир хил бўлиши керак", pfOptional: "ихтиёрий", pfNote: "Изоҳ", pfNotePlaceholder: "Изоҳ (ихтиёрий)...", pfJoTotal: "Заказ суммаси", pfJoPaid: "Тўланган", pfJoRemaining: "Қолдиқ", pfJoHistory: "Тўловлар тарихи", pfJoNoPayments: "Ҳали тўлов йўқ", pfJoLoading: "Юкланмоқда...", pfDeleteText: "Тўлов ўчирилади ва контрагент баланси қайтарилади.", pfNameLabel: "Номи *", pfNamePlaceholder: "Номи", pfCommissionAdd: "Комиссия қўшиш", pfCommission: "Комиссия (2-чиқим)", pfCommissionPct: "Фоиз", pfSecondAdd: "2-кассага бўлиб тўлаш", pfSecondTitle: "2-касса кирими (нақд + карта)", pfSecondCashboxLabel: "2-касса", pfSecondAmountLabel: "2-касса суммаси", pfSecondRemove: "Бекор", pfSecondCashboxRequired: "2-касса танланиши шарт", pfSecondSameCashbox: "2-касса бошқа бўлиши керак", pfSecondInvalid: "2-касса суммаси нотўғри", pfCommissionInvalid: "Комиссия суммаси нотўғри", pfCommissionEmpty: "Комиссия категориялари белгиланмаган — «Бошқариш» орқали танланг.", pfCommissionMgrTitle: "Комиссия категориялари", pfCommissionMgrHint: "Белгиланган чиқим категориялари комиссияда танлаш учун чиқади.",
    loadError: "Юклашда хато", cancel: "Бекор", save: "Сақлаш", add: "Қўшиш", saved: "Янгиланди", added: "Қўшилди", deleted: "Ўчирилди", error: "Хато", delete: "Ўчириш", deleteTitle: "Ўчиришни тасдиқланг", nameRequired: "Номи киритилиши шарт", search: "Қидириш...", notFound: "Топилмади", selectCp: "Контрагент танланг...", loadMore: "Яна юклаш", clearSelection: "Танловни тозалаш", edit: "Таҳрирлаш", back: "Орқага", kirim: "Кирим", chiqim: "Чиқим", insufficient: "Кассада етарли маблағ йўқ",
    thName: "Номи", thCurrency: "Валюта", thBranch: "Филиал", thBalance: "Баланс", thActions: "Амаллар", thNumber: "Рақам", thDate: "Сана", thType: "Тур", thCp: "Контрагент", thCashbox: "Касса", thCategory: "Категория", thAmount: "Сумма", thStatus: "Статус", thDesc: "Тавсиф", thDirection: "Йўналиш",
    debtsTitle: "Қарзлар", debtsSubtitle: "Қарздорлар ва кредиторлар (контрагентлар баланси)", none: "Йўқ", debtors: "Қарздорлар", debtorsHint: "Дебитор қарздор", creditors: "Кредиторлар", creditorsHint: "Кредитор қарздорлар",
    cbReportLoadError: "Ҳисоботни юклашда хато", cbBase: "Асосий", cbTitle: "Корхона баланси", cbSubtitle: "Ҳар валюта бўйича соф қиймат (net worth)", noData: "Маълумот йўқ", cbGrandTotal: "Умумий соф қиймат ({base}га келтирилган)", cbConvertedNote: "Бошқа валюталар ташкилот курслари бўйича ҳисобланган", cbRatesLabel: "Курс", cbInventory: "Товар қолдиқлари тан нархи", cbInventoryHint: "Хомашё ва тайёр маҳсулотлар", cbReceivables: "Контрагентдан ҳақдорлик", cbReceivablesHint: "Контрагентлар тўлайдиган пуллар", cbCash: "Кассадаги пуллар", cbCashHint: "Шу валютадаги кассалар", cbPayables: "Контрагентга қарз", cbPayablesHint: "Контрагентларга тўланадиган қарз", cbFormula: "Формула: Склад тан нархи + Контрагентдан ҳақдорлик + Кассадаги пуллар − Контрагентга қарз. Склад тан нархи фақат асосий валютада ({base}) сақланади.",
    pnlTitle: "P&L (Фойда ва зарар)", pnlSubtitle: "Тушум → Таннарх → Ялпи фойда → Харажатлар → Соф фойда (асосий валютада)", pnlReport: "P&L ҳисобот", pnlRevenue: "Тушум (сотувлар)", pnlCogs: "− Таннарх", pnlGross: "= Ялпи фойда", pnlOpex: "− Операцион харажатлар", pnlOperating: "= Операцион фойда", pnlFinancial: "− Молиявий харажатлар (фоиз/банк)", pnlSecLabel: "P&L туркуми", pnlSecHint: "Операцион — одатий харажат; Молиявий — банк фоизи/кредит; Ҳисобга олинмайди — таъминотчига тўлов/қарз.", pnlSec_operating: "Операцион", pnlSec_financial: "Молиявий", pnlSec_excluded: "Ҳисобга олинмайди", pnlNet: "≡ Соф фойда", pnlNote: "Эслатма: Таннарх жорий таннарх асосида (тахминий). Солиқлар ва кредитлар ҳисобга олинмайди.", pnlExpenseDetail: "Операцион харажатлар тафсилоти", pnlNoExpense: "Харажат тўловлари йўқ", pnlCashFlow: "Пул оқими (қўшимча)", pnlCashFlowHint: "Касса ҳаракати, P&L га таъсир қилмайди", pnlNetFlow: "Соф оқим",
    cbxCurrencyRequired: "Валюта танланиши шарт", cbxEditTitle: "Кассани таҳрирлаш", cbxNewTitle: "Янги касса", cbxNameLabel: "Номи *", cbxNamePlaceholder: "Касса номи", cbxCurrencyLabel: "Валюта *", cbxBranchLabel: "Филиал", cbxBranchNone: "— Танланмаган —", cbxBranchHint: "Филиаллар Созламалар → Корхона бўлимидан қўшилади.", cbxTitle: "Кассалар", cbxSubtitle: "Кассалар рўйхати", cbxAdd: "Касса қўшиш", cbxNotFound: "Касса топилмади", cbxNotFoundHint: "Янги касса қўшинг", cbxDeleteText: "кассаси ўчирилади.",
    ccTitle: "Касса картаси", ccNotFound: "Касса топилмади", ccBackToList: "Рўйхатга қайтиш", ccConversion: "Конвертация", ccReceipt: "Нақд кирим (харид)", ccOverhead: "Ишлаб чиқариш харажати", ccConvOut: "(чиқди)", ccConvIn: "(кирди)", ccCurrentBalance: "Жорий баланс", ccJournal: "Ҳаракатлар журнали", ccNoMovements: "Ҳаракатлар йўқ",
    convCashboxesRequired: "Кассалар танланиши шарт", convSameCashbox: "Бир хил касса танлаб бўлмайди", convSameCurrency: "Бир хил валютани конвертация қилиб бўлмайди", convTransferMode: "Кўчириш (курссиз, 1:1)", convTransferTitle: "Кассадан кассага кўчириш", convTransferBtn: "Кўчириш", convTransferTag: "Кўчириш", convFromAmountInvalid: "Бериладиган сумма нотўғри", convRateRequired: "Курсни киритинг", convDone: "Конвертация бажарилди", convEditTitle: "Конвертацияни таҳрирлаш", convNewTitle: "Янги конвертация", convFrom: "Кассадан", convSelect: "Танланг...", convBalance: "Баланс:", convGive: "Берилади (сумма)", convTo: "Кассага", convRate: "Курс", convReverse: "Тескари", convReceive: "Олинади", convAuto: "(автоматик)", convDoBtn: "Бажариш", convTitle: "Конвертация", convSubtitle: "Кассадан кассага валюта ўтказиш", convNewBtn: "Конвертация", convNotFound: "Конвертация топилмади", convNotFoundHint: "Янги конвертация яратинг", convThGive: "Берилади", convThReceive: "Олинади", convDeleteText: "конвертацияси ўчирилади.", convVerifyBtn: "Тасдиқлаш", convVerified: "Конвертация тасдиқланди", convVerifiedBadge: "Тасдиқланган", convDraftBadge: "Тасдиқланмаган", convVerifiedAt: "Тасдиқланди", convLockedHint: "Тасдиқланган ҳужжат таҳрирланмайди",
    payTitle: "Тўловлар", paySubtitle: "Пул кирими ва чиқими", paySearch: "Рақам ёки контрагент...", payFilterCp: "Контрагент", payFilterCashbox: "Барча кассалар", payFilterCategory: "Барча категориялар", payIncoming: "Пул кирими", payOutgoing: "Пул чиқими", payNotFound: "Тўлов топилмади", payNotFoundHint: "Пул кирими ёки чиқими яратинг", payDeleteText: "тўлови ўчирилади. Контрагент баланси қайтарилади.",
    pfIncomingTitle: "Кирим тўлови", pfOutgoingTitle: "Чиқим тўлови", pfJoSelect: "Заказ танланг...", pfClearSelection: "— Танловни тозалаш —", pfJoSearch: "Рақам ёки мижоз...", pfNewCp: "Янги контрагент", cpAdded: "Контрагент қўшилди", pfPhone: "Телефон", pfPhonePlaceholder: "+998 ...", smTitle: "Статусларни бошқариш", smNew: "Янги статус", smNamePlaceholder: "Статус номи...", catIncomingTitle: "Кирим категориялари", catOutgoingTitle: "Чиқим категориялари", catNew: "Янги категория", catNamePlaceholder: "Категория номи...",
    ppIncomingTitle: "КИРИМ ОРДЕРИ", ppOutgoingTitle: "ЧИҚИМ ОРДЕРИ", ppDate: "Сана:", ppReceivedFrom: "Қабул қилинди (ким)", ppGivenTo: "Берилди (ким)", ppCashbox: "Касса:", ppCategory: "Категория:", ppAmount: "Сумма:", ppNote: "Изоҳ:", ppSignedIncomingLeft: "Топширди (имзо)", ppSignedOutgoingLeft: "Берди (имзо)", ppSignedIncomingRight: "Қабул қилди (имзо)", ppSignedOutgoingRight: "Олдим (имзо)",
  },

  contracts: { optional: "ихтиёрий", legalNamePlaceholder: "Юридик номи", managerLabel: "Масъул (ким ишлайди)", managerNone: "Танланмаган",
    selectCp: "Контрагент танланг...", search: "Қидириш...", notFound: "Топилмади",
    editTitle: "Шартномани таҳрирлаш", newTitle: "Янги шартнома",
    number: "Рақам", date: "Сана", cpLabel: "Контрагент *", legalName: "Юридик ном", inn: "ИНН", legalMissing: "Контрагент картасида юридик ном/ИНН тўлдирилмаган.", amount: "Сумма *", currency: "Валюта",
    description: "Тавсиф", descPlaceholder: "Шартнома мавзуси...", note: "Изоҳ", notePlaceholder: "Ихтиёрий...",
    filesLabel: "Файллар (PDF, сканлар)", cancel: "Бекор", save: "Сақлаш", add: "Қўшиш",
    cpRequired: "Контрагент танланиши шарт", amountInvalid: "Сумма нотўғри",
    saved: "Янгиланди", added: "Қўшилди", error: "Хато", loadError: "Юклашда хато", deleted: "Ўчирилди",
    title: "Шартномалар", subtitle: "Шартномалар реестри — ҳар бир шартномага автоматик рақам берилади",
    searchPlaceholder: "Рақам, контрагент...", newBtn: "Шартнома", empty: "Шартнома йўқ", emptyHint: "Янги шартнома қўшинг",
    thCp: "Контрагент", thAmount: "Сумма", thCreatedBy: "Яратди", thActions: "Амаллар",
    deleteTitle: "Ўчиришни тасдиқланг", deleteText: "шартномаси ўчирилади.", delete: "Ўчириш",
  },

  aktSverka: { tabCustomer: "Мижоз билан", tabSupplier: "Таъминотчи билан",
    selectCp: "Контрагент танланг...", search: "Қидириш...", notFound: "Топилмади",
    cpRequired: "Контрагент танланиши шарт", error: "Хато", copied: "Нусха олинди",
    regenConfirm: "Эски ҳавола бекор қилинади ва янгиси яратилади. Давом этилсинми?", urlUpdated: "Ҳавола янгиланди",
    title: "Акт-сверка", subtitle: "Контрагент билан ўзаро ҳисоб-китоб ҳужжати", cpLabel: "Контрагент",
    fromDate: "Бошланиш санаси", toDate: "Тугаш санаси", generate: "Ҳосил қилиш", print: "Чоп этиш / PDF",
    permUrlTitle: "Контрагент учун доимий URL", permUrlHint: "Бу URL доимий — контрагент уни сақлаб қўйиб исталган вақтда ўз ҳисоб-китобини кўриши мумкин. Даврлар public саҳифада танланади.",
    copyTitle: "Нусха олиш", copy: "Нусха", regenTitle: "Янги URL (эски бекор бўлади)", regen: "Янгилаш",
    loadError: "Юклашда хато", linkError: "Ҳавола очилмади", printShort: "Чоп / PDF",
    docTitle: "АКТ СВЕРКА", docSubtitle: "Контрагентлар ўртасидаги ўзаро ҳисоб-китоб", ourOrg: "Бизнинг ташкилот", tel: "Тел", period: "Давр",
    noTx: "Бу даврда транзаксиялар йўқ", currencyLabel: "Валюта", thDate: "Сана", thDoc: "Ҳужжат", thDebit: "Дебет", thCredit: "Кредит", thBalance: "Сальдо",
    openingBalance: "Бошланғич сальдо", totalRow: "Жами",
    theyOweA: " томонидан бизга ", theyOweB: " қарз қолди.", weOwePre: "Биз томонидан ", weOweMid: "'га ", weOweSuf: " қарз қолди.",
    noDebtPre: "Бу даврда ", noDebt: "қарз йўқ (сальдо 0)",
    signOur: "Бизнинг ташкилот томонидан:", signCp: "Контрагент томонидан:", signLine: "(Ф.И.Ш., лавозим, имзо, сана)",
  },

  sklad: { allCategories: "Барча категориялар", lowOnly: "Кам қолганлар", totalValue: "Жами қолдиқ қиймати", thCategory: "Категория", thValue: "Қиймат",
    loadError: "Юклашда хато", cancel: "Бекор", save: "Сақлаш", add: "Қўшиш", saved: "Янгиланди", added: "Қўшилди", deleted: "Ўчирилди", error: "Хато", delete: "Ўчириш", deleteTitle: "Ўчиришни тасдиқланг", nameRequired: "Номи киритилиши шарт", total: "Жами", thName: "Номи", thProduct: "Маҳсулот", thUom: "Ўлчов", sku: "SKU",
    sbTitle: "Қолдиқлар", sbSubtitle: "Маҳсулотларнинг омбор бўйича қолдиғи", sbSearch: "Маҳсулот қидириш...", sbNotFound: "Маҳсулот топилмади", sbNotFoundHint: "Қолдиқлар кирим ҳужжатлари орқали шаклланади",
    rTitle: "Жами таннархлар", rSubtitle: "Маҳсулотлар қолдиғи ва таннарх асосида омбор қиймати", rKpi: "Омбор умумий қиймати (таннарх)", rEmpty: "Қолдиқ йўқ", rStock: "Қолдиқ", rCost: "Таннарх", rValue: "Қиймат",
    tTitle: "Кўчиришлар", tSubtitle: "Омборлараро товар кўчириш", tNew: "Кўчириш", tSearch: "Рақам бўйича қидириш...", tNotFound: "Кўчириш топилмади", tNotFoundHint: "Янги кўчириш ҳужжати яратинг", tNumber: "Рақам", tDate: "Сана", tDirection: "Йўналиш", tProducts: "Маҳсулотлар", itemCountSuffix: "та маҳсулот",
    whEditTitle: "Омборни таҳрирлаш", whNewTitle: "Янги омбор", whNameLabel: "Номи *", whNamePlaceholder: "Омбор номи", whTitle: "Омборхоналар", whSubtitle: "Омборлар рўйхати", whAdd: "Омбор қўшиш", whNotFound: "Омбор топилмади", whNotFoundHint: "Янги омбор қўшинг", thActions: "Амаллар", whDeleteText: "омбори ўчирилади.",
    lsTitle: "Кам қолган маҳсулотлар", lsSubtitleSearch: "Маҳсулот топиб, минимал қолдиқни белгиланг", lsSubtitle: "Қолдиғи белгиланган минимал даражадан паст маҳсулотлар", lsAlerts: "Огоҳлантиришлар", lsEmpty: "Кам қолган маҳсулот йўқ", lsEmptyHint: "Минимал қолдиқни белгилаш учун маҳсулот қидиринг", lsLow: "Кам", lsEnough: "Етарли", lsCurrentStock: "Жорий қолдиқ", lsMinStock: "Минимал қолдиқ", lsStatus: "Ҳолат",
    tfNotFound: "Топилмади", tfCatalogEmpty: "Каталог бўш", tfTypeProduct: "Маҳсулот номини ёзинг...", tfDocLoadError: "Ҳужжат юкланмади", tfFromRequired: "Қайердан омбор танланиши шарт", tfToRequired: "Қайерга омбор танланиши шарт", tfSameWarehouse: "Бир хил омбор танлаб бўлмайди", tfDateInvalid: "Сана нотўғри (DD/MM/YYYY HH:MM)", tfMinOneProduct: "Камида битта маҳсулот киритинг", tfMoved: "Кўчирилди", back: "Орқага", tfHeaderTitle: "Омборлараро кўчириш", tfDocTitle: "Кўчириш ҳужжати", tfFrom: "Қайердан *", tfTo: "Қайерга *", tfSelectWarehouse: "Омбор танланг...", tfThAvailFrom: "Мавжуд (қайердан)", tfQty: "Миқдор", tfAvailable: "Мавжуд", tfNote: "Изоҳ", tfNotePlaceholder: "Изоҳ...", tfDeleteText: "кўчириш ҳужжати ўчирилади. Қолдиқлар қайтарилади.",
  },

  cpCard: {
    kind: { purchaseOrder: "Харид буюртмаси", purchaseReceipt: "Кирим", purchaseReturn: "Харид қайтариш", salesOrder: "Сотув буюртмаси", salesInvoice: "Сотув", salesReturn: "Сотув қайтариш" },
    payIn: "Тўлов (кирим)", payOut: "Тўлов (чиқим)", weOwe: "Биз қарздормиз", theyOwe: "Бизга қарздор",
    tabs: { documents: "Ҳужжатлар", payments: "Тўловлар", ledger: "Баланс тарихи", products: "Товарлар", prices: "Нархлар" },
    loadError: "Юклашда хато", cardTitle: "Контрагент картаси", back: "Орқага", notFound: "Контрагент топилмади", backToList: "Рўйхатга қайтиш", debtTitle: "Қарздорлик",
    thKind: "Тур", thNumber: "Рақам", thDate: "Сана", thStatus: "Статус", thSum: "Сумма", thCashbox: "Касса", thCategory: "Категория", thDoc: "Ҳужжат", thChange: "Ўзгариш", thBalance: "Баланс",
    noDocuments: "Ҳужжатлар йўқ", noPayments: "Тўловлар йўқ", ledgerEmpty: "Баланс тарихи бўш",
  },

  counterparties: { addBtn: "Қўшиш", statTotal: "Жами", statCustomers: "Мижозлар", statSuppliers: "Таъминотчилар",
    folderNamePlaceholder: "Папка номи...", cancel: "Бекор", error: "Хато", subFolderTitle: "Суб-папка қўшиш",
    folders: "Папкалар", statusMgrTitle: "Статусларни бошқариш", editLabel: "Таҳрирлаш", newStatus: "Янги статус",
    statusNamePlaceholder: "Статус номи...", save: "Сақлаш", add: "Қўшиш",
    all: "Барчаси", statusless: "Статуссиз", status: "Статус",
    loadError: "Юклашда хато", saved: "Янгиланди", added: "Қўшилди", deleted: "Ўчирилди",
    title: "Контрагентлар", subtitle: "Мижозлар ва таъминотчилар", allFolders: "Барча папкалар", searchPlaceholder: "Қидириш...",
    notFound: "Контрагент топилмади", createHint: "Янги контрагент қўшинг",
    weOwe: "Биз қарздормиз", theyOwe: "Бизга қарздор",
    thName: "Номи", thPhone: "Телефон", thContacts: "Контактлар", thDebt: "Қарздорлик", thActions: "Амаллар", contactsSuffix: "контакт",
    editTitle: "Таҳрирлаш", newTitle: "Контрагент қўшиш", nameLabel: "Номи", namePlaceholder: "Компания ёки шахс номи",
    folderLabel: "Папка", noFolder: "Папкасиз", configure: "Созлаш",
    phone: "Телефон", phonePlaceholder: "+998 90 000 00 00", email: "Email", emailPlaceholder: "example@mail.com", comment: "Коммент", commentPlaceholder: "Изоҳ...",
    contactsTitle: "Контактли шахслар", addContact: "Қўшиш", noContacts: "Контакт қўшилмаган",
    cName: "Исми", cNamePlaceholder: "Исм Фамилия", cRole: "Лавозими", cRolePlaceholder: "Директор, Менежер...", cPhone: "Номери",
    requisitesTitle: "Реквизитлар", inn: "INN (СТИР)", innPlaceholder: "123456789",
    legalName: "Юридик номи", legalNamePlaceholder: "ООО \"Компания\"", legalAddr: "Юридик манзил", legalAddrPlaceholder: "Тошкент ш., Чилонзор т., ...",
    bankAccount: "Банк ҳисоб рақами", bankPlaceholder: "2020 8000 0000 0000 0000", update: "Янгилаш",
    location: "Манзил / Жойлашув", locationPlaceholder: "Шаҳар, кўча, бино...",
    deleteTitle: "Ўчиришни тасдиқланг", deleteText: "контрагенти ўчирилади.", delete: "Ўчириш",
  },

  uomNames: {
    pcs: "дона", kg: "килограмм", g: "грамм", t: "тонна", l: "литр", ml: "миллилитр",
    m: "метр", cm: "сантиметр", mm: "миллиметр", "m²": "квадрат метр", "m³": "куб метр", km: "километр",
    pair: "жуфт", roll: "рулон", box: "қути", pack: "пачка", bag: "қоп", set: "тўплам",
    bottle: "шиша", can: "банка", cyl: "баллон", coil: "ғалтак", spool: "ғалтак (spool)", sheet: "лист", bunch: "боғлам",
    hr: "соат", min: "дақиқа", day: "кун", week: "ҳафта", month: "ой", year: "йил",
    visit: "ташриф", session: "сеанс", project: "лойиҳа", page: "саҳифа", word: "сўз", trip: "рейс",
  },
  productForm: {
    variantsTitle: "Вариантлар", variantsHint: "Ранг, ўлчам каби атрибутлар бўйича вариантлар",
    attributesTitle: "Атрибутлар", attrNamePlaceholder: "Атрибут номи (мас. Ранг)", attrValuePlaceholder: "Қиймат қўшиш + Enter",
    addAttribute: "Атрибут қўшиш", generateVariants: "Вариантларни яратиш",
    variantsListTitle: "Вариантлар", totalStock: "Жами қолдиқ", variantCol: "Вариант", imageCol: "Расм", skuCol: "SKU", priceCol: "Нарх", costCol: "Таннарх", stockCol: "Қолдиқ",
    stockHint: "Ҳар вариант учун бошланғич қолдиқни киритинг; маҳсулот қолдиғи = вариантлар йиғиндиси",
    ptTitle: "Сотув нарх турлари", ptHint: "Қўшинг, таҳрирланг ёки ўчиринг", ptPlaceholder: "Масалан: Улгуржи, Чакана...", ptAdd: "Нарх турини қўшиш",
    added: "Қўшилди", deleted: "Ўчирилди", error: "Хато",
    images: "Расмлар", imagesHint: "та • биринчиси муқова", setCover: "Муқова қил", uploading: "Юкланмоқда...", imageDrop: "Расм танланг ёки бу ерга ташланг", imageError: "Расм юклашда хато",
    dimsTitle: "Ўлчамлари", dimsHint: "— бир дона учун", length: "Узунлик", width: "Кенглик", height: "Баландлик",
    pkgTitle: "Қадоқлаш бирликларини", pkgBase: "Асосий:", pkgNoBase: "Аввал \"Маълумотлар\" бўлимидан асосий ўлчов бирлигини (UOM) танланг",
    pkgUnit: "Қадоқлаш бирлик", pkgQty: "Миқдори", pkgUomSelect: "Ўлчов...", pkgAdd: "Қадоқлаш қўшиш",
    editTitle: "Таҳрирлаш", newProduct: "Янги маҳсулот", newService: "Янги хизмат",
    saved: "Янгиланди", saveError: "Хато юз берди", saving: "Сақланмоқда...", update: "Янгилаш", save: "Сақлаш", cancel: "Бекор қилиш",
    nameLabel: "Номи", productNamePlaceholder: "Маҳсулот номи", serviceNamePlaceholder: "Хизмат номи",
    infoTitle: "Маълумотлар", descLabel: "Тавсиф", descPlaceholder: "Маҳсулот ҳақида қисқача...",
    folderLabel: "Папка", noFolder: "Папкасиз", select: "Танланг...", skuLabel: "SKU", skuPlaceholder: "Масалан: PRD-001",
    pricesTitle: "Нархлар", buyPrice: "Харид нархи", salePricesTitle: "Сотув нархлари", statusTitle: "Ҳолат", back: "Орқага", uomLabel: "Ўлчов бирлиги", minStockLabel: "Минимал қолдиқ", minStockHint: "Қолдиқ шу миқдордан кам ёки тенг бўлса — \"Кам қолдиқ\"да чиқади (0 = назорат йўқ)", configure: "Созлаш", active: "Фаол", activeBadge: "Актив", isManufacturedLabel: "Ишлаб чиқарилади", prodNormaTitle: "Ишлаб чиқариш нормаси", prodNormaHint: "1 бирлик маҳсулот ишлаб чиқарилганда сарф бўладиган хомашёлар", prodNormaAdd: "Қўшиш", prodNormaProduct: "Хомашё", prodNormaQty: "Миқдор", prodNormaUom: "Бирлик", prodNormaFooter: "Ишлаб чиқаришда бу маҳсулот танланганда норма автоматик тортилади", manufacturingUomLabel: "Ишлаб чиқариш ўлчов бирлиги", manufacturingUomHint: "Ишлаб чиқариш форmasida бу маҳсулот танланганда автоматик қўйилади.", manufacturingUomNone: "Белгиланмаган (ихтиёрий)",
    mkixCodeLabel: "МКИX код", mkixCodePlaceholder: "Масалан: 3926909709",
    nameRequired: "Маҳсулот номи киритилиши шарт", uomRequired: "Ўлчов бирлиги танланиши шарт",
  },

  products: {
    variantTag: "вариант",
    typeAll: "Ҳаммаси", product: "Маҳсулот", service: "Хизмат",
    cols: { category: "Папка", uom: "ЎБ", sku: "SKU", costPrice: "Таннарх", avgCost: "Ўрт. таннарх", salePrice: "Сотув нархи", stock: "Қолдиқ", description: "Тавсиф", createdAt: "Яратилган", updatedAt: "Янгиланган", isActive: "Ҳолат" },
    active: "Фаол", inactive: "Фаол эмас",
    searchPlaceholder: "Қидириш...", colsMenuTitle: "Устунларни созлаш", colsMenu: "Устунлар", colsAll: "Ҳаммаси", colsDefault: "Стандарт",
    folders: "Папкалар", newFolder: "Янги папка", allFolders: "Ҳаммаси", noFolders: "Папка йўқ", mobileAllFolders: "Ҳаммаси (папка)",
    resizeHint: "Судраб кенглигини ўзгартиринг (қайта ишлаш учун икки марта босинг)",
    thName: "Номи", notFound: "Маҳсулот топилмади", createHint: "Биринчи маҳсулот ёки хизматни қўшинг", inactiveBadge: "Нофаол", stockLabel: "Қолдиқ",
    uomRequired: "Ўлчов бирлиги танланг", editTitle: "Таҳрирлаш —", newProductTitle: "+ Янги маҳсулот", newServiceTitle: "+ Янги хизмат",
    nameLabel: "Номи", productNamePlaceholder: "Маҳсулот номи", serviceNamePlaceholder: "Хизмат номи",
    skuLabel: "SKU / Код", uomLabel: "Ўлчов бирлиги", select: "Танланг...",
    folderLabel: "Папка", noFolder: "Папкасиз", salePrice: "Сотув нархи", costPriceLabel: "Тан нархи", descLabel: "Тавсиф", optional: "Ихтиёрий...",
    activeCheck: "Фаол", cancel: "Бекор", save: "Сақлаш", add: "Қўшиш", saving: "Сақланмоқда...",
    folderEditTitle: "Папкани таҳрирлаш", folderNamePlaceholder: "Папка номи", parentFolder: "Юқори папка", rootFolder: "Асосий папка",
    deleteTitle: "Ўчиришни тасдиқланг", deleteText: "ни ўчиришни тасдиқлайсизми? Бу амални қайтариб бўлмайди.", delete: "Ўчириш", deleting: "Ўчирилмоқда...",
    saved: "Янгиланди", added: "Қўшилди", folderSaved: "Папка янгиланди", folderAdded: "Папка қўшилди", deleted: "Ўчирилди", folderDeleted: "Папка ўчирилди", error: "Хато юз берди",
  },

  files: {
    empty: "Ҳали файл юкланмаган", fileName: "Файл", uploading: "Юкланмоқда...", upload: "Файл юклаш",
    hint: "PDF, расм, Word, Excel — максимум 15MB", uploaded: "Юкланди", uploadError: "Юклашда хато",
  },

  smeta: {
    title: "Смета", save: "Сақлаш",
    companyName: "Корхона номи", companyNamePh: "Корхона номини киритинг",
    directorName: "Директор Ф.И.О.", directorNamePh: "Фамилия Исм Шариф",
    colName: "Иш номи", colCountry: "Мамлакат", colUom: "Ўлчов бирлиги",
    colQty: "Миқдор", colPrice: "Нарх", colDeliveryCost: "Етказиб бериш",
    colVat: "ҚҚС %", colTotal: "ҚҚС билан жами",
    total: "Итого", addRow: "Қатор қўшиш",
    comment: "Изоҳ", commentPh: "Қўшимча изоҳлар...",
    validUntil: "Тижорат таклифи амал қилиш муддати", validUntilLabel: "Муддати:",
    positions: "Товарлар ва хизматлар", preview: "Кўриш", close: "Ёпиш",
    download: "PDF юклаб олиш", printPdf: "Чоп этиш / PDF", orderNum: "Буюртма №",
    delivery: "Етказиб бериш қиймати", vat: "ҚҚС", grandTotal: "Жами ҚҚС билан",
    shareLink: "Улашиш", linkCopied: "Нусхаланди!", linkError: "Ҳавола яроқсиз",
  },

  jobOrderForm: { dimW: "Эни", dimL: "Бўйи", back: "Орқага", title: "Заказ", deleteTitle: "Корзинага ўтказиш", deleteText: "Заказ корзинага ўтказилади. Хомашё қолдиғи қайтарилади.",
    procStatus: { waiting: "Бошланмаган", "in-progress": "Жараёнда", paused: "Паузада", done: "Якунланди", problem: "Проблемада" },
    durMin: "дақ", durHour: "соат", distFromInstall: "Ўрнатиш жойидан масофа",
    select: "Танланг...", search: "Қидириш...", clearSelection: "— Танловни тозалаш —", notFound: "Топилмади",
    nameRequired: "Номи киритилиши шарт", customerAdded: "Мижоз қўшилди", error: "Хато",
    newCustomer: "Янги мижоз", nameLabel: "Номи", customerNamePlaceholder: "Мижоз номи", phone: "Телефон", cancel: "Бекор", add: "Қўшиш",
    docLoadError: "Ҳужжат юкланмади", cashboxRequired: "Касса танланиши шарт", amountInvalid: "Сумма нотўғри",
    paymentReceived: "Пул қабул қилинди", movedToTrash: "Корзинага ўтказилди", customerRequired: "Мижоз танланиши шарт",
    warehouseRequired: "Омбор танланиши шарт", agreedInvalid: "Келишилган сумма нотўғри",
    deadlineRequired: "Топшириш муддати киритилиши шарт", managerRequired: "Лойиҳа менежери танланиши шарт", agreedRequired: "Келишилган сумма киритилиши шарт", descriptionRequired: "Тавсиф киритилиши шарт",
    savedToast: "Сақланди", createdToast: "Яратилди", saveFirst: "Аввал заказни сақланг", delivered: "Етказиб берилди", reverted: "Бекор қилинди",
    modalTitle: "Янги заказ", modalCreate: "Яратиш ва давом этиш", modalHint: "Сақлангач жараёнлар, расходлар ва ҳисоб-китобни қўшасиз.",
    fManager: "Лойиҳа менежери", managerNone: "— Танланмаган —",
    fSketch: "Эскиз (расм/PDF)", sketchUpload: "Эскиз юклаш",
    basicInfo: "Асосий маълумотлар", moveLeft: "Чапга суриш", moveRight: "Ўнгга суриш",
    toTrash: "Корзинага", print: "Чоп", printTitle: "Чоп этиш", deliver: "Якунланди", revertDelivery: "Якунлашни бекор қилиш", confirmAction: "Тасдиқлаш", startAction: "Жараёнга ўтказиш", completeAction: "Якунлаш", statusChanged: "Статус ўзгартирилди", startNeedProcess: "Аввал жараён (этап) қўшинг", startNeedResponsible: "Ҳар бир жараёнга масъул шахс бириктиринг", save: "Сақлаш",
    deliveredLockTitle: "Етказиб берилган заказни таҳрир қилиш учун аввал бекор қилинг",
    deliveredBanner: "Етказиб берилган. Таҳрир қилиш учун аввал етказиб беришни бекор қилинг.",
    invoiceTitle: "Шот-фактура юбориш керак",
    invoiceText1: "Бу заказ бўйича иш тугади. Контрагент ", invoiceText2: "'га ", invoiceText3: " шартномаси бўйича шот-фактура юборилиши керак.",
    contractAmount: "Шартнома суммаси:",
    fNumber: "Рақам", fDate: "Сана", fCustomer: "Мижоз", customerPlaceholder: "Мижоз...", newCustomerTitle: "Янги мижоз қўшиш",
    fContract: "Шартнома", noContract: "— Шартномасиз —", fAgreedPrice: "Келишилган сумма", fCurrency: "Валюта", fDeadline: "Топшириш муддати",
    fWarehouse: "Омбор (хомашё)", fFolder: "Папка", noFolder: "— Папкасиз —",
    fDescription: "Тавсиф (нима ишланади)", fShortName: "Қисқа ном", shortNamePlaceholder: "Масалан: Ошхона мебели", shortNameRequired: "Қисқа ном киритилиши шарт", sketchRequired: "Эскиз юклаш шарт", descPlaceholder: "Стол, ошхона мебели...",
    fLocation: "Ўрнатиш локацияси", fLocationHint: "— мижоздаги ҳавола (Google Maps, Yandex)", openLink: "Ҳаволани очиш", copyLink: "Нусха олиш", copied: "Нусхаланди",
    createdBy: "Яратди:", priceLabel: "Нарх:", paidLabel: "Тўлов:", debtLabel: "Қарз:", workedLabel: "Ишланди:", receivePayment: "Пул қабул қилиш",
    processes: "Жараёнлар", addProcess: "Жараён", noProcesses: "Жараёнлар йўқ. \"+ Жараён\" тугмасини босинг.",
    addProcessTitle: "Янги жараён", editProcessTitle: "Жараённи таҳрирлаш", addProcessHint: "Бўлим ва маъсулни танланг", deptRequired: "Бўлим танланиши шарт",
    pDept: "Бўлим", pResponsible: "Маъсул", pStatus: "Ҳолат", pLabor: "Меҳнат", pAllocated: "Ажратилган сумма", pNote: "Изоҳ", pNotePlaceholder: "Изоҳ / махсус кўрсатма...", workedShort: "Ишланди:", historyTitle: "Вақт тарихи", calLoad: "заказ", calBusy: "банд", historyEmpty: "Ҳали ҳаракат йўқ", fromProposal: "Бу заказ таклифдан яратилган:", viewProposal: "Таклифни кўриш", proposalTitle: "Таклиф", prDate: "Сана", prCustomer: "Мижоз", prAssignee: "Бириктирилган ходим", prCreatedBy: "Яратди", prDescription: "Тавсиф", prNote: "Изоҳ", prFiles: "Файллар",
    trackStart: "Бошла", trackPause: "Пауза", trackDone: "Тугат", trackProblem: "Проблема", trackResume: "Давом",
    materials: "Расходлар (хомашё)", addRow: "Қатор", noMaterials: "Расход йўқ. \"Қатор\" тугмасини босинг.",
    mProduct: "Маҳсулот", mQty: "Миқдор", mUom: "ЎБ", mCost: "Таннарх", mSum: "Сумма", mProcess: "Жараён",
    stockLeft: "Қолдиқ",
    selectVariant: "Вариант танланг",
    uomPlaceholder: "дона", costFromProductTitle: "Маҳсулот картасидан олинган таннарх", costOwnTitle: "Бу заказ учун таннарх", totalExpense: "Жами расход",
    files: "Файллар ва лойиҳалар",
    totalsTitle: "Якуний ҳисоб", tAgreed: "Келишилган сумма", tMaterials: "Хомашё", tLabor: "Меҳнат", tTotalCost: "Жами таннарх", tOtherExpenses: "Бошқа харажатлар", otherExpenses: "Бошқа харажатлар", addExpense: "Харажат қўшиш", noExpenses: "Харажат йўқ", expCashbox: "Касса", expCashboxHint: "Фақат заказ валютасидаги ({cur}) кассалар", expCashboxRequired: "Касса танланг", expAmount: "Сумма", expAmountRequired: "Суммани киритинг", expNote: "Изоҳ", expNotePlaceholder: "Харажат тавсифи…", expAdded: "Харажат қўшилди", expDeleted: "Харажат ўчирилди", tProfit: "Фойда",
    totalsHint: "Сақлангач ҳақиқий таннарх (FIFO/ўртача) ёзилади ва фойда аниқ бўлади.",
    freezeAction: "Музлатиш", unfreezeAction: "Давом эттириш",
    freezeTitle: "Заказни музлатиш (пауза)", freezeHint: "Музлатилганда муддат узайтирилади. Давом эттирилганда ўтган вақт қайтарилмайди.",
    freezeUntilLabel: "Қачон давом эттирилади (сана)",
    freezeExtendInfo: "Муддат {days} кун узайтирилади.",
    freezeConfirm: "Музлатиш", freezeDateRequired: "Давом этиш санаси киритилиши шарт",
    freezeSuccess: "Заказ музлатилди", unfreezeSuccess: "Заказ давом эттирилди",
    frozenBanner: "Музлатилган (пауза)", frozenFrom: "дан:", frozenUntil: "гача:",
    deleteTextInvoice: " Автоматик фактура ҳам ўчирилади ва мижоз баланси қайтарилади.",
    payTitle: "Пул қабул қилиш", remainingDebt: "Қолдиқ қарз:", cashbox: "Касса", noCashbox: "валютасидаги касса топилмади",
    amount: "Сумма", payNote: "Изоҳ", optional: "Ихтиёрий...", receive: "Қабул қилиш",
  },

  proposals: {
    title: "Тижорат таклифи", countSuffix: "та", new: "Таклиф", newTitle: "Янги таклиф", editTitle: "Таклифни таҳрирлаш", colNumber: "Рақам", colDate: "Сана", colCustomer: "Мижоз", colDescription: "Тавсиф", colAmount: "Сумма", colAssignee: "Ходим", colCreatedBy: "Яратди",
    searchPlaceholder: "Рақам, мижоз, тавсиф...", notFound: "Таклиф топилмади", loadError: "Юклашда хато",
    resizeHint: "Судраб кенглигини ўзгартиринг", backToList: "Рўйхатга қайтиш",
    emptyTitle: "Таклиф танланмаган", emptyHint: "Чапдан танланг ёки янги яратинг",
    tabs: { open: "Очиқ", won: "Ютди", lost: "Рад" },
    statWon: "ютди", statLost: "рад", statOpen: "очиқ",
    status: { new: "Янги", "in-discussion": "Муҳокамада", won: "Ютди (заказ)", lost: "Рад этилди" },
    customerSelect: "Мижоз танланг...", search: "Қидириш...", searchEmpty: "Топилмади", clearSelection: "Танловни тозалаш", fAssignee: "Бириктирилган ходим", assigneePlaceholder: "Ходим танланг...", assigneeHint: "Белгиланган ходим ўз саҳифасида (Ишларим) бошладим/тугатдим босади", fManager: "Масъул (Договор)", managerPlaceholder: "Админ ёки лойиҳа менежери...", managerHint: "Договор шу фойдаланувчига боғланади", workStatus: { waiting: "Бошланмаган", "in-progress": "Жараёнда", done: "Тугатилди" },
    docLoadError: "Ҳужжат юкланмади", customerRequired: "Мижоз танланиши шарт",
    savedToast: "Сақланди", createdToast: "Яратилди", error: "Хато",
    markedLost: "Рад этилди деб белгиланди", deleteConfirm: "Бу таклифни ўчирасизми?", deletedToast: "Ўчирилди",
    lostBannerTitle: "Рад этилган таклиф", reasonLabel: "Сабаб:",
    fNumber: "Рақам", fDate: "Сана", fStatus: "Ҳолат", fCurrency: "Валюта", fCustomer: "Мижоз",
    fAgreedPrice: "Келишилган сумма", fWarehouse: "Омбор (заказ учун)", notSelected: "— Танланмаган —",
    fDescription: "Тавсиф (нима ишланади)", descPlaceholder: "Мижоз дизайни / лойиҳаси тавсифи...",
    fAdvance: "Аванс (брон) суммаси", advancePaid: "Аванс тўланган", fNote: "Изоҳ", optional: "Ихтиёрий...", fFiles: "Файллар (эскиз/расм/ҳужжат)", createdBy: "Яратди:",
    lostModalTitle: "Таклифни рад этиш", lostReasonLabel: "Сабаб (ихтиёрий):", lostReasonPlaceholder: "Мижоз қарор қилди...",
    winModalText: "Янги заказ (JobOrder) яратилади ва бу таклифга боғланади. Жараёнлар ва материаллар заказ ичида қўшилади.",
  },

  jobOrders: { title: "Заказлар", newOrder: "Заказ", notFound: "Заказ топилмади", statAgreed: "Жами сумма", statPaid: "Тўланган", statDebt: "Қарз", statCount: "Заказлар сони", colsReorderHint: "Суриб тартибини ўзгартиринг", filterCustomer: "Мижоз", filterAllCustomers: "Барча мижозлар", filterAllManagers: "Барча менежерлар", filterYear: "Йил", filterPeriod: "Давр", filterWholeYear: "Бутун йил", filterAllMonths: "Барча ойлар", filterClear: "Тозалаш",
    subtitle: "Мижоз буюртмаси: ишлаб чиқариш → етказиб бериш",
    searchPlaceholder: "Рақам, мижоз, тавсиф...",
    createHint: "Янги заказ яратинг",
    loadError: "Юклашда хато",
    thNumber: "Рақам",
    thActions: "Амаллар",
    filterAll: "Ҳаммаси",
    tabAll: "Ҳаммаси", tabFrozen: "Музлатилган", overdue: "Муддат ўтиб кетди", costOverrun: "Таннарх ошиб кетди",
    status: { new: "Янги", confirmed: "Тасдиқланган", "in-progress": "Жараёнда", delivered: "Якунланган", cancelled: "Бекор қилинди" },
    cols: { sketch: "Эскиз", shortName: "Қисқа ном",
      date: "Сана", customer: "Мижоз", description: "Тавсиф", folder: "Папка", processes: "Жараёнлар",
      manager: "Лойиҳа менежери", agreedPrice: "Келишилган", paid: "Тўланган", debt: "Қарз",
      totalCost: "Таннарх", materialsCost: "Хомашё", laborCost: "Меҳнат",
      profit: "Фойда", status: "Статус", createdBy: "Яратди", expectedDeliveryDate: "Топшириш",
      deliveryDate: "Етказилди сана", currency: "Валюта",
    },
    colsMenu: "Устунлар", colsMenuTitle: "Устунларни созлаш", colsAll: "Ҳаммаси", colsDefault: "Стандарт",
    folders: "Папкалар", newFolder: "Янги папка", allFolders: "Ҳаммаси", noFolder: "Папкасиз",
    noFolders: "Папка йўқ", mobileAllFolders: "Ҳаммаси (папка)",
    folderEdit: "Папкани таҳрирлаш", folderNameLabel: "Номи", folderNamePlaceholder: "Папка номи",
    parentFolder: "Юқори папка", rootFolder: "Асосий папка",
    folderDeleteTitle: "Папкани ўчириш",
    folderDeleteText: "папкаси ўчирилади. Ичидаги заказлар сақланади (фақат папка боғланиши олиб ташланади).",
    trashTitle: "Корзинага ўтказиш",
    trashText: "заказ корзинага ўтказилади. Хомашё қолдиғи қайтарилади.",
    cancel: "Бекор", save: "Сақлаш", add: "Қўшиш", delete: "Ўчириш", toTrash: "Корзинага",
    saved: "Янгиланди", addedToast: "Қўшилди", deletedToast: "Ўчирилди", movedToTrash: "Корзинага ўтказилди", error: "Хато",
    resizeHint: "Судраб кенглигини ўзгартиринг (қайта тиклаш учун икки марта босинг)",
  },

  // Auth
  login: "Кириш",
  register: "Рўйхатдан ўтиш",
  logout: "Чиқиш",
  email: "Email",
  phone: "Телефон",
  password: "Парол",
  confirmPassword: "Паролни тасдиқланг",
  forgotPassword: "Паролни унутдингизми?",

  // Register
  createOrganization: "Ташкилот яратиш",
  organizationName: "Ташкилот номи",
  organizationType: "Ташкилот тури",
  yourName: "Исмингиз",
  yourEmail: "Email манзилингиз",
  yourPassword: "Парол",
  alreadyHaveAccount: "Аккаунтингиз борми?",
  dontHaveAccount: "Аккаунтингиз йўқми?",

  // Org types
  retail: "Чакана савдо",
  wholesale: "Улгуржи савдо",
  manufacturing: "Ишлаб чиқариш",
  service: "Хизмат кўрсатиш",
  other: "Бошқа",

  // Dashboard
  dashboard: "Бош саҳифа",
  welcome: "Хуш келибсиз",

  // Common
  save: "Сақлаш",
  cancel: "Бекор қилиш",
  delete: "Ўчириш",
  edit: "Таҳрирлаш",
  add: "Қўшиш",
  search: "Қидириш",
  loading: "Юкланмоқда...",
  error: "Хато",
  success: "Муваффақиятли",

  // Errors
  required: "Бу майдон тўлдирилиши шарт",
  invalidEmail: "Email манзили нотўғри",
  passwordMin: "Парол камида 4 та белгидан иборат бўлиши керак",
  passwordMatch: "Пароллар мос келмади",

  // Login page
  login_page: {
    server: "Сервер",
    serverPlaceholder: "server...",
    checking: "текширилмоқда...",
    serverNotFound: "Сервер топилмади",
    serverNotFoundHint: "«{slug}» номли сервер мавжуд эмас. Манзилни текширинг.",
    phonePlaceholder: "90 123 45 67",
    passwordPlaceholder: "••••••",
    submitting: "Кирилмоқда...",
    forgotPassword: "Паролни унутдингизми?",
    rights: "© 2025 CRM Line. Барча ҳуқуқлар ҳимояланган.",
  },

  // Sales module
  sales: {
    dateLocale: "uz-Cyrl-UZ",
    types: {
      orders:   { label: "Буюртмалар", subtitle: "Мижоз буюртмалари", docLabel: "Сотув буюртмаси" },
      invoices: { label: "Сотувлар",   subtitle: "Сотув фактуралари (ҳисоб-фактуралар)", docLabel: "Сотув фактураси" },
      returns:  { label: "Қайтаришлар", subtitle: "Мижоздан товар қайтариш", docLabel: "Сотув қайтариш" },
    },
    statusDraft: "Қоралама",
    statusConfirmed: "Тасдиқланган",
    searchPlaceholder: "Рақам ёки мижоз...",
    notFound: "Ҳужжат топилмади",
    createHint: "Янги ҳужжат яратинг",
    thNumber: "Рақам",
    thDate: "Сана",
    thCustomer: "Мижоз",
    thLines: "Қаторлар",
    thSum: "Сумма",
    thStatus: "Статус",
    thVerified: "Verified",
    thState: "Ҳолат",
    thCurrency: "Валюта", thNote: "Изоҳ",
    thActions: "Амаллар",
    linesSuffix: "та",
    view: "Кўриш",
    edit: "Таҳрирлаш",
    deleteConfirmTitle: "Ўчиришни тасдиқланг",
    deleteConfirmText: "ҳужжати ўчирилади.",
    deleteInvoiceExtra: " Қолдиқ ва мижоз қарзи қайтарилади.",
    cancel: "Бекор",
    deleteBtn: "Ўчириш",
    deleted: "Ўчирилди",
    loadError: "Юклашда хато",
    error: "Хато",
  },

  // Purchases module
  purchases: {
    dateLocale: "uz-Cyrl-UZ",
    types: {
      receipts: { label: "Киримлар",  subtitle: "Таъминотчи шот-фактуралари (киримлар)", docLabel: "Кирим ҳужжати" },
      returns:  { label: "Қайтаришлар", subtitle: "Таъминотчига товар қайтариш", docLabel: "Харид қайтариш" },
    },
    statusDraft: "Қоралама",
    statusConfirmed: "Тасдиқланган",
    searchPlaceholder: "Рақам ёки таъминотчи...",
    notFound: "Ҳужжат топилмади",
    createHint: "Янги ҳужжат яратинг",
    thNumber: "Рақам",
    thDate: "Сана",
    thSupplier: "Таъминотчи",
    thLines: "Қаторлар",
    thSum: "Сумма",
    thStatus: "Статус",
    thVerified: "Verified",
    thState: "Ҳолат",
   thCurrency: "Валюта", thWarehouse: "Омбор", thNote: "Изоҳ", thPayment: "Тўлов", payCash: "Нақд", payCredit: "Қарз",
    thActions: "Амаллар",
    linesSuffix: "та",
    view: "Кўриш",
    edit: "Таҳрирлаш",
    deleteConfirmTitle: "Ўчиришни тасдиқланг",
    deleteConfirmText: "ҳужжати ўчирилади.",
    cancel: "Бекор",
    deleteBtn: "Ўчириш",
    deleted: "Ўчирилди",
    loadError: "Юклашда хато",
    error: "Хато",
  },

  // Sales form page
  salesForm: {
    docTypes: {
      orders: "Сотув буюртмаси",
      invoices: "Сотув фактураси",
      returns: "Сотув қайтариш",
    },
    back: "Орқага",
    delete: "Ўчириш",
    print: "Чоп этиш",
    copy: "Нусха",
    cancel: "Бекор",
    save: "Сақлаш",
    add: "Қўшиш",
    error: "Хато",
    statusManage: "Статусларни бошқариш",
    statusEdit: "Таҳрирлаш",
    statusNew: "Янги статус",
    statusNamePlaceholder: "Статус номи...",
    statusAdd: "Қўшиш",
    productSearchPlaceholder: "Маҳсулот қидириш...",
    productNotFoundCreate: "Топилмади. Янги товарни",
    productNotFoundCreate2: "орқали яратинг.",
    catalogEmpty: "Каталог бўш — + орқали товар қўшинг",
    productTypeName: "Маҳсулот номини ёзинг...",
    notFound: "Топилмади",
    searchPlaceholder: "Қидириш...",
    customerSelect: "Мижоз танланг...",
    customerAdded: "Мижоз қўшилди",
    newCustomer: "Янги мижоз",
    nameRequired: "Номи *",
    customerNamePlaceholder: "Мижоз номи",
    phone: "Телефон",
    nameRequiredToast: "Номи киритилиши шарт",
    warehouseSelect: "Омбор танланг...",
    warehouseUpdated: "Янгиланди",
    warehouseAdded: "Омбор қўшилди",
    editWarehouse: "Омборни таҳрирлаш",
    newWarehouse: "Янги омбор",
    warehouseNamePlaceholder: "Омбор номи",
    currency: "Валюта",
    baseLabel: "асосий",
    uploaded: "Юкланди",
    uploadError: "Юклашда хато",
    file: "Файл",
    uploading: "Юкланмоқда...",
    uploadFile: "Файл юклаш",
    noFiles: "Ҳали файл юкланмаган",
    fileHint: "PDF, расм, Word, Excel — максимум 15MB",
    productAdded: "Товар қўшилди",
    newProduct: "Янги товар",
    productNamePlaceholder: "Товар номи",
    costPrice: "Таннарх",
    docLoadError: "Ҳужжат юкланмади",
    customerRequired: "Мижоз танланиши шарт",
    warehouseRequired: "Омбор танланиши шарт",
    deadlineRequired: "Топшириш муддати киритилиши шарт",
    managerRequired: "Лойиҳа менежери танланиши шарт",
    agreedRequired: "Келишилган сумма киритилиши шарт",
    descriptionRequired: "Тавсиф киритилиши шарт",
    currencyRequired: "Валюта танланиши шарт",
    cashboxRequired: "Касса танланиши шарт",
    dateInvalid: "Сана нотўғри (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Етказиб бериш санаси нотўғри (DD/MM/YYYY)",
    needQty: "Камида битта позицияга миқдор киритинг",
    saved: "Сақланди",
    created: "Қўшилди",
    copyNeedRow: "Нусха олиш учун камида битта қатор керак",
    copyCreated: "Нусха яратилди",
    deleted: "Ўчирилди",
    productAlready: "Бу маҳсулот аллақачон қўшилган",
    dateLabel: "Сана:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    statusless: "Статуссиз",
    verified: "Тасдиқланган",
    counterparty: "Контрагент *",
    newCounterpartyTitle: "Янги контрагент қўшиш",
    warehouse: "Склад",
    editWarehouseTitle: "Складни таҳрирлаш",
    newWarehouseTitle: "Янги склад қўшиш",
    currencyReq: "Валюта *",
    payment: "Тўлов",
    payCredit: "Насия (мижоз қарздор)",
    payCreditHint: "Мижоз балансига ёзилади — кейин Пул кирими орқали тўланади.",
    payCash: "Нақд тўлов (кассага тушади)",
    payCashHint: "Сумма дарҳол кассага тушади, мижоз балансига таъсир қилмайди.",
    cashbox: "Касса",
    selectPlaceholder: "Танланг...",
    notSelected: "— Танланмаган —",
    arrivalDate: "Келиш сана",
    createInvoice: "Сотув яратиш",
    customerReq: "Мижоз *",
    invoiceCreated: "Сотув яратилди (складдан чиқарилди)",
    newCustomerTitle: "Янги мижоз қўшиш",
    priceType: "Нарх тури",
    priceTypeDefault: "Стандарт (1-нарх)",
    cashboxBalance: "қолдиқ",
    noCashbox: "\"{currency}\" валютасидаги касса топилмади (ёки сизга бириктирилмаган)",
    tabItems: "Товар ва хизматлар",
    tabFiles: "Файллар",
    thName: "Номи",
    thSells: "Сотилади",
    thUom: "Бирлик",
    uomSelect: "Бирлик",
    uomRequired: "Ҳар бир маҳсулот учун ўлчов бирлигини танланг",
    overStock: "\"{name}\" омборда етарли эмас (мавжуд: {qty} {uom})",
    thAvailable: "Мавжуд",
    thPrice: "Нарх",
    thDiscount: "Чегирма %",
    thSum: "Сумма",
    thVatRate: "ҚҚС ставка",
    thVatAmount: "ҚҚС миқдори",
    thTotal: "Жами",
    newProductTitle: "Янги товар яратиш",
    total: "Жами сумма",
    totalVat: "ҚҚС",
    grandTotal: "Жами (ҚҚС билан)",
    note: "Изоҳ",
    notePlaceholder: "Изоҳ ёки қўшимча маълумот...",
    saleConfirmed: "Сотув тасдиқланган",
    saleConfirmedHint: "Маҳсулот қолдиғи камайди ва мижоз қарзи ошди (+{amount}).",
    deleteConfirmTitle: "Ўчиришни тасдиқланг",
    deleteConfirmText: "ҳужжати бутунлай ўчирилади.",
    partyLabel: "Мижоз",
  },

  // Purchase form page
  purchaseForm: {
    docTypes: {
      orders: "Харид буюртмаси",
      receipts: "Кирим ҳужжати",
      returns: "Харид қайтариш",
    },
    back: "Орқага",
    delete: "Ўчириш",
    save: "Сақлаш",
    createReceipt: "Кирим яратиш",
    cancel: "Бекор",
    error: "Хато",
    statusManage: "Статусларни бошқариш",
    statusEdit: "Таҳрирлаш",
    statusNew: "Янги статус",
    statusNamePlaceholder: "Статус номи...",
    statusAdd: "Қўшиш",
    productSearchPlaceholder: "Маҳсулот қидириш...",
    productNotFoundCreate: "Топилмади. Янги товарни",
    productNotFoundCreate2: "орқали яратинг.",
    catalogEmpty: "Каталог бўш — + орқали товар қўшинг",
    productTypeName: "Маҳсулот номини ёзинг...",
    notFound: "Топилмади",
    supplierSelect: "Таъминотчи танланг...",
    supplierAdded: "Таъминотчи қўшилди",
    newSupplier: "Янги таъминотчи",
    nameRequired: "Номи *",
    supplierNamePlaceholder: "Таъминотчи номи",
    phone: "Телефон",
    warehouseSelect: "Омбор танланг...",
    warehouseUpdated: "Янгиланди",
    warehouseAdded: "Омбор қўшилди",
    editWarehouse: "Омборни таҳрирлаш",
    newWarehouse: "Янги омбор",
    warehouseNamePlaceholder: "Омбор номи",
    nameRequiredToast: "Номи киритилиши шарт",
    add: "Қўшиш",
    currency: "Валюта",
    uploadError: "Юклашда хато",
    file: "Файл",
    uploading: "Юкланмоқда...",
    uploadFile: "Файл юклаш",
    uploaded: "Юкланди",
    noFiles: "Ҳали файл юкланмаган",
    fileHint: "PDF, расм, Word, Excel — максимум 15MB",
    productAdded: "Товар қўшилди",
    newProduct: "Янги товар",
    productNamePlaceholder: "Товар номи",
    costPrice: "Таннарх",
    docLoadError: "Ҳужжат юкланмади",
    procLoadError: "Снабжения сўрови юкланмади",
    productAlready: "Бу маҳсулот аллақачон қўшилган",
    selectVariant: "Вариант танланг",
    variantRequired: "Вариантли маҳсулот учун вариант танланг",
    supplierRequired: "Таъминотчи танланиши шарт", linkedProductsHint: "Фақат ушбу таъминотчи товарларини кўрсатяпти",
    warehouseRequired: "Омбор танланиши шарт",
    currencyRequired: "Валюта танланиши шарт",
    cashboxRequired: "Касса танланиши шарт",
    dateInvalid: "Сана нотўғри (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Етказиб бериш санаси нотўғри (DD/MM/YYYY)",
    needQty: "Камида битта позицияга миқдор киритинг",
    saved: "Сақланди",
    created: "Қўшилди",
    copyNeedRow: "Нусха олиш учун камида битта қатор керак",
    copyCreated: "Нусха яратилди",
    receiptCreated: "Кирим яратилди ва омборга киритилди",
    deleted: "Ўчирилди",
    statusless: "Статус йўқ",
    dateLabel: "Сана:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    verified: "Тасдиқланди",
    verifiedLockTitle: "Тасдиқланган ҳужжатни фақат админ қайтара олади",
    counterparty: "Контрагент *",
    newCounterpartyTitle: "Янги контрагент қўшиш",
    editWarehouseTitle: "Омборхонани таҳрирлаш",
    newWarehouseTitle: "Янги омборхона қўшиш",
    arrivalDate: "Келиш сана",
    dateOnlyPlaceholder: "DD/MM/YYYY",
    currencyReq: "Валюта *",
    paymentMode: "Тўлов шакли",
    payDebt: "Қарз (таъминотчи қарздор)",
    payDebtHint: "Таъминотчи баланси кўтарилади — кейин Пул чиқими орқали тўланади.",
    payCash: "Нақд (кассадан тўланади)",
    payCashHint: "Кассадан сумма дарҳол чиқади, таъминотчи балансига таъсир қилмайди.",
    cashbox: "Касса",
    selectPlaceholder: "Танланг...",
    noCashbox: "\"{currency}\" валютасидаги касса топилмади (ёки сизга бириктирилмаган)",
      convRate: "Конвертация курси", convEdit: "Курсни таҳрирлаш", convDeducted: "Кассадан ечилади",
    thName: "Номи",
    thNeed: "Керак",
    thReceived: "Олинди",
    thOrdered: "Буюртма",
    thAvailable: "Мавжуд",
    thPrice: "Нарх",
    thDiscount: "Чегирма %",
    thSum: "Сумма",
    newProductTitle: "Янги товар яратиш",
    overReceiveError: "Керакли миқдордан ортиқ олиб бўлмайди",
    excludeFromReceipt: "Бу Киримга киритмаслик",
    total: "Жами",
    note: "Изоҳ",
    notePlaceholder: "Изоҳ ёки қўшимча маълумот...",
    receiptConfirmed: "Кирим тасдиқланган",
    receiptConfirmedHint: "Маҳсулот қолдиғи янгиланди ва таъминотчи баланси ошди (+{amount}).",
    deleteConfirmTitle: "Ўчиришни тасдиқланг",
    deleteConfirmText: "ҳужжати бутунлай ўчирилади.",
    partyLabel: "Таъминотчи",
    warehouse: "Омборхона",
    warehouseNone: "— Танланмаган —",
    baseLabel: "асосий",
    print: "Чоп этиш",
    copy: "Нусха",
    tabItems: "Товар ва хизматлар",
    tabFiles: "Ҳужжатлар",
    searchPlaceholder: "Қидириш...",
    docNumberDash: "—",
    addRow: "Қатор қўшиш",
  },

  // Procurement editor + form-page chrome
  procEditor: {
    pageTitle: "Снабжения сўрови",
    back: "Орқага",
    lockedTitle: "Ҳужжат таҳрирланмайди",
    lockedText: "Бу сўров ўтган кунга тегишли ({date}). Ўтган кунлардаги ҳужжатлар фақат кўриб чиқиш учун очиқ.",
    toTrash: "Корзинага",
    createReceipt: "Кирим яратиш",
    close: "Ёпиш",
    cancel: "Бекор",
    save: "Сақлаш",
    number: "Рақам",
    date: "Сана",
    needBy: "Топшириш муддати",
    assignee: "Снабженист (масъул)",
    statusPrefix: "Ҳолат:",
    receiptsLinked: "· {n} та кирим боғланган",
    overdue: "Муддати ўтган",
    neededProducts: "Керакли маҳсулотлар",
    rowsCount: "{n} та қатор",
    thProduct: "Маҳсулот",
    thImage: "Расм",
    thNeed: "Керак",
    thUom: "Бирлик",
    thReceived: "Олинган",
    thRemaining: "Қолдиқ",
    thNote: "Изоҳ",
    uomPlaceholder: "дона",
    optional: "Ихтиёрий",
    addRow: "Қатор қўшиш",
    note: "Изоҳ",
    notePlaceholder: "Ихтиёрий...",
    attachments: "Илова (расм/файл)",
    trashModalTitle: "Корзинага ўтказиш",
    trashModalText: "Сўров корзинага ўтказилади. Боғланган кирим ҳужжатлари сақланиб қолади.",
    needRow: "Камида битта қатор киритинг", assigneeRequired: "Снабжинист танланиши шарт",
    saved: "Сақланди",
    created: "Яратилди",
    movedToTrash: "Корзинага ўтказилди",
    loadDocError: "Ҳужжат юкланмади",
    error: "Хато",
  },

  // Procurement (Снабжения) list
  procurement: {
    dateLocale: "uz-Cyrl-UZ",
    title: "Снабжения",
    countSuffix: "та сўров",
    newRequestShort: "Сўров",
    newRequestTitle: "Янги сўров",
    searchPlaceholder: "Рақам, изоҳ...",
    notFound: "Сўров топилмади",
    unassigned: "— белгиланмаган",
    positionsSuffix: "та позиция", boughtOf: "{total} дан {bought} олинди", uploadError: "Юклашда хато", imgZoom: "Катталаштириш", selectVariant: "Вариант танланг",  thDate: "Сана", thProduct: "Маҳсулот", thNeed: "Керак", thUom: "Бирлик", thNote: "Изоҳ", optional: "Ихтиёрий...", thBuy: "Олиш", addRow: "Қатор қўшиш", flatHint: "Пастдаги қатор орқали маҳсулот қўшинг — у бугунги зайавкага ёзилади. Муддати ўтган қаторлар қизил.", error: "Хато",
    resizeHint: "Судраб кенглигини ўзгартиринг (қайта тиклаш учун икки марта босинг)",
    backToList: "Рўйхатга қайтиш",
    newDocTitle: "Янги снабжения сўрови",
    emptyTitle: "Сўров танланмаган",
    emptyHint: "Чап томондан рўйхатдан танланг ёки янги сўров яратинг",
    loadError: "Юклашда хато",
    tabs: {
      overdue: "Муддати ўтган",
      new: "Янги",
      partial: "Қисман",
      fulfilled: "Бажарди",
    },
    status: {
      new: "Янги",
      partial: "Қисман",
      fulfilled: "Бажарилди",
      cancelled: "Бекор",
    },
  },

  // Dashboard home (Бош саҳифа)
  dashboardHome: {
    dateLocale: "uz-Cyrl-UZ",
    greeting: "Хуш келибсиз, {name}!",
    today: "Бугун {date}",
    noAccess: "Кўрсаткичларни кўриш учун рухсат йўқ ёки маълумот юкланмади.",
    noWidgets: "Сизнинг ролингиз учун бош саҳифада кўрсаткичлар йўқ. Чап менюдан бўлимни танланг.",
    kpiTodaySales: "Бугунги сотув",
    kpiMonthSales: "Ойлик сотув",
    kpiMonthProfit: "Ойлик фойда",
    kpiInventory: "Омбор қиймати",
    trendTitle: "Сотув динамикаси",
    trendPeriod: "14 кун",
    debtTitle: "Қарздорлик",
    debtTheyOwe: "Дебитор қарздор",
    debtWeOwe: "Кредитор қарздорлар",
    debtNet: "Соф даромад",
    counterparties: "Контрагентлар",
    cashTitle: "Касса қолдиқлари",
    cashEmpty: "Касса йўқ",
    topDebtorsTitle: "Энг катта қарздорлар",
    noDebtors: "Қарздор йўқ", debtorThresholdHint: "Минимал сумма (меёрни белгилаш)",
    viewAll: "Барчаси",
    recentTitle: "Сўнгги операциялар",
    recentEmpty: "Ҳали операциялар йўқ",
    recent: {
      salesInvoice: "Сотув",
      purchaseReceipt: "Кирим",
      paymentIn: "Тўлов кирим",
      paymentOut: "Тўлов чиқим",
    },
  },

  // Sidebar navigation (keyed by NAV_ITEMS key)
  nav: { "purchases-orders": "Заявкалар", "job-orders": "Заказлар", "job-orders-orders": "Заказлар", integrations: "Интеграциялар",
    dashboard: "Бош саҳифа",
    contacts: "Контактлар",
    tasks: "Вазифалар",
    inbox: "Inbox",
    calls: "Қўнғироқлар",
    reviews: "Отзивлар",
    funnels: "Воронкалар",
    purchases: "Товар ва хизматлар харид",
    "purchases-procurement": "Снабжения",
    "purchases-receipts": "Киримлар",
    "purchases-returns": "Қайтаришлар",
    sales: "Товар ва хизматлар сотуви",
    "sales-orders": "Буюртмалар",
    "sales-invoices": "Сотувлар",
    "sales-returns": "Қайтаришлар",
    "job-orders-proposals": "Тижорат таклифи",
    inventory: "Товар ва хизматлар",
    counterparties: "Контрагентлар",
    "counterparties-list": "Контрагентлар",
    "counterparties-contracts": "Шартномалар",
    "counterparties-aktsverka": "Акт-сверка",
    sklad: "Омбор",
    "sklad-balances": "Товар қолдиқлари",
    "sklad-valuation": "Товарлар тан нархлари",
    "sklad-transfers": "Омборлар ўртасида товар кўчириш",
    "sklad-warehouses": "Омборхоналар",
    "sklad-lowstock": "Кам қолдиқ",
    finance: "Молия бўлими",
    "finance-balance": "Корхона баланси",
    "finance-pnl": "Фойда ва зарар",
    "finance-analysis": "Анализ",
    "finance-payments": "Тўловлар", "finance-requests": "Сўровлар",
    "finance-debts": "Қарзлар",
    "finance-conversions": "Конвертация",
    "finance-cashboxes": "Кассалар",
    "finance-scheduled": "Мажбурий тўловлар",
    "finance-assets": "Активлар",
    production: "Ишлаб чиқариш",
    "production-orders": "Ишлаб чиқариш",
    "production-packaging": "Упаковка",
    "production-bom": "Рецептлар (BOM)",
  },

  analysis: {
    title: "Анализ",
    subtitle: "Ойлар кесимида келган пулнинг расход нормаларига тақсимланиши",
    income: "Келган пул",
    allocated: "Ажратилган",
    spent: "Сарфланган",
    available: "Мавжуд",
    carryIn: "Олдинги ойдан",
    normSum: "Нормалар йиғиндиси",
    normHint: "Нормалар йиғиндиси 100% бўлиши тавсия этилади.",
    empty: "Расход категориялари йўқ.",
    remain: "Қолдиқ",
    over: "Ошиб кетди",
    toNextMonth: "Келаси ойга ўтади",
    loadError: "Маълумотни юклашда хатолик",
    error: "Хатолик юз берди",
    date: "Сана",
    total: "Жами",
    noSpend: "Бу ойда расход қилинмаган.",
    spentTotal: "Жами сарфланган",
    allocatedRow: "Мавжуд (норма)",
    carryShort: "(ўтган ой)",
    diffRow: "Фарқ → кейинги ойга",
    diffHint: "Фарқ мусбат — қолдиқ кейинги ойга ўтади; манфий — бюджет ошиб кетди.",
    readonly: "Фақат ўқиш учун",
    noCounterparty: "Контрагентсиз",
    unitK: "минг", unitM: "млн", unitB: "млрд",
    configNorms: "Фоизларни созлаш",
    normsTitle: "Категория фоизлари (норма)",
    normsHint: "Ҳар бир категорияга ойлик келган пулдан неча фоиз ажратилишини белгиланг.",
    normsSaved: "Фоизлар сақланди",
    byCategoryTitle: "Категориялар бўйича (ойлик)",
    colName: "Номи",
    colSumma: "Сумма",
    colNorma: "Норма",
    colReal: "Реал %",
    colResult: "Натижа",
    resultHint: "Натижа = Норма − Реал. Мусбат (яшил) — нормадан кам сарфланди; манфий (қизил) — ошиб кетди.",
    save: "Сақлаш",
    cancel: "Бекор",
  },

  // Account settings page
  account: {
    title: "Аккаунт созламалари",
    subtitle: "Шахсий маълумотларни таҳрирлаш",
    personalInfo: "Шахсий маълумотлар",
    name: "Исм",
    email: "Email",
    emailHint: "(паролни тиклаш учун)",
    emailPlaceholder: "example@mail.com",
    phone: "Телефон",
    phoneHint: "Телефон рақамни ўзгартириб бўлмайди",
    save: "Сақлаш",
    saving: "Сақланмоқда...",
    profileUpdated: "Профил янгиланди",
    genericError: "Хато юз берди",
    changePassword: "Паролни ўзгартириш",
    currentPassword: "Жорий парол",
    newPassword: "Янги парол",
    confirmPassword: "Янги паролни тасдиқланг",
    passwordMismatch: "Янги пароллар мос келмайди",
    passwordTooShort: "Парол камида 4 та белги бўлиши керак",
    passwordChanged: "Парол муваффақиятли ўзгартирилди",
    changePasswordBtn: "Паролни ўзгартириш",
    namePlaceholder: "Тўлиқ исм",
    role: "Рол",
    hide: "Ёпиш",
    show: "Очиш",
  },

  // Settings page
  settings: {
    title: "Созламалар",
    back: "Орқага",
    tabs: {
      general: "Умумий созламалар",
      branding: "Брендинг",
      modules: "Меню",
      users: "Фойдаланувчилар",
      workers: "Ишчилар",
      roles: "Роллар",
      currencies: "Валюталар",
      uom: "Ўлчов бирликлари",
      company: "Корхона",
      assets: "Активлар",
      trash: "Корзина",
      funnels: "Воронкалар",
      tasks: "Вазифалар",
      "deal-sources": "Савдо манбалари",
      "close-reasons": "Ёпиш сабаблари",
      "lead-forms": "Формалар",
      goals: "Мақсадлар",
      integrations: "Интеграциялар",
      inbox: "Inbox",
      atc: "Телефония (ATC)",
      audit: "Аудит журнали",
    },
    groups: {
      general: "Умумий", crm: "CRM", channels: "Интеграциялар", system: "Тизим",
    },
    branding: {
      title: "Брендинг",
      subtitle: "Ташкилот номи, логоси ва бренд ранги — дастур шу кўринишда очилади",
      orgName: "Ташкилот номи",
      orgNamePlaceholder: "Компания номи",
      logo: "Логотип",
      upload: "Юклаш",
      removeLogo: "Ўчириш",
      brandColor: "Бренд ранги",
      defaultGreen: "Стандарт (яшил)",
      customColor: "Махсус ранг", solidTitle: "Sidebar/юқори панель асл рангда", solidHint: "Ёқилса — чап меню ва юқори панель танланган рангнинг айнан ўзида кўринади (тўқлаштирилмайди). Ўчиқ бўлса — ҳозиргидек тўқ соя.",
      preview: "Кўриниш",
      primaryBtn: "Асосий тугма",
      badge: "Ёрлиқ",
      linkText: "Ҳавола матни",
      save: "Сақлаш",
      imageOnly: "Фақат расм файли",
      uploadError: "Юклашда хато",
      nameRequired: "Ташкилот номи киритилиши шарт",
      saved: "Брендинг сақланди",
      error: "Хато",
    },
    users: {
      countPrefix: "Жами",
      countSuffix: "та фойдаланувчи", searchPlaceholder: "Исм ёки телефон...", noResults: "Ҳеч нарса топилмади",
      add: "Қўшиш",
      thUser: "Фойдаланувчи",
      thPhone: "Телефон",
      thRole: "Рол",
      thDept: "Бўлим", noDept: "Бўлимсиз",
      thStatus: "Ҳолат",
      you: "Сиз",
      userType: "Ходим тури", userTypeNone: "Оддий ходим", userTypeHint: "Снабженист / жараён ходими / лойиҳа менежери ролини танланг (ихтиёрий)",
      snabjenist: "Снабженист",
      active: "Фаол",
      inactive: "Фаол эмас",
      editTitle: "Таҳрирлаш",
      changePasswordTitle: "Паролни ўзгартириш",
      deleteTitle: "Ўчириш",
      newUser: "Янги фойдаланувчи",
      editUser: "Фойдаланувчини таҳрирлаш",
      name: "Исм",
      namePlaceholder: "Тўлиқ исм",
      role: "Рол", position: "Лавозим",
      dept: "Бўлим",
      deptNone: "— Танланмаган —", deptMulti: "Бўлимлар (бир нечта)", noDeptsYet: "Ҳали бўлим йўқ", cpFolders: "Контрагент папкалари (доступ)", cpFoldersHint: "Снабженист фақат белгиланган папкалардаги таъминотчиларни кўради. Ҳеч бири белгиланмаса — барчаси.", noFoldersYet: "Ҳали папка йўқ",
      snabjenistHint: "Ёқилган бўлса, Снабжения формасида \"Маъсул\" рўйхатида кўринади",
      customRole: "Рол (RBAC)",
      customRoleNone: "— Чекловсиз (тўлиқ) —",
      customRoleHint: "Махсус рол бириктирилса, фойдаланувчи шу рол рухсатлари билан чекланади. owner/admin доим тўлиқ.", roleHint: "Администратор - барча ҳуқуқлар (RBAC ишламайди). User - чекланган; пастда махсус рол танлаш мумкин.", adminFullHint: "Администратор барча модулларга кира олади - махсус рол (RBAC) керак эмас.",
      processWorker: "Жараён ходими",
      projectManager: "Лойиҳа менежери", cashier: "Кассир",
      permissions: "Рухсатлар",
      cashboxes: "Бириктирилган кассалар (снабженист учун)",
      cashboxesHint: "Фойдаланувчи нақд Кирим қилганда фақат шу кассалардан танлай олади. Бўш қолдирилса, фойдаланувчи нақд Кирим қила олмайди.",
      phone: "Телефон",
      phonePlaceholder: "90 123 45 67",
      email: "Email",
      emailHint: "(паролни тиклаш учун)",
      emailPlaceholder: "example@mail.com",
      password: "Парол",
      passwordPlaceholder: "Камида 6 та белги",
      newPassword: "Янги парол",
      passwordModalTitle: "Парол —",
      cancel: "Бекор",
      save: "Сақлаш",
      saving: "Сақланмоқда...",
      change: "Ўзгартириш",
      deleteUser: "Фойдаланувчини ўчириш",
      deleteConfirmPrefix: "",
      deleteConfirmSuffix: "ни ўчиришни тасдиқлайсизми? Бу амални қайтариб бўлмайди.",
      deleteBtn: "Ўчириш",
      deleting: "Ўчирилмоқда...",
      accountOwner: "Account owner",
      loadError: "Фойдаланувчиларни юклаб бўлмади",
      updated: "Фойдаланувчи янгиланди",
      passwordChanged: "Парол ўзгартирилди",
      deleted: "Фойдаланувчи ўчирилди",
      added: "Фойдаланувчи қўшилди",
      genericError: "Хато юз берди",
      passwordTooShort: "Парол камида 4 та белгидан иборат бўлиши керак",
      roles: { owner: "Эгаси", admin: "Администратор", user: "Фойдаланувчи", cashier: "Кассир" },
      perms: { products: "Маҳсулотлар", clients: "Мижозлар", suppliers: "Таъминотчилар", sales: "Сотув", purchases: "Харид", reports: "Ҳисоботлар" },
    },
    currencies: {
      baseTitle: "Асосий валюта",
      baseSubtitle: "Барча нархлар шу валютада кўрсатилади",
      change: "Ўзгартириш",
      baseTag: "Асосий",
      basePickTitle: "Асосий валютани танланг",
      basePickHint: "Биринчи танлаган валютангиз асосий бўлади",
      addTitle: "Қўшимча валюталар",
      addSubtitle: "Асосий валютага нисбатан курс кўрсатилади",
      add: "Қўшиш",
      empty: "Ҳали қўшимча валюта қўшилмаган",
      pickBaseModal: "Асосий валютани танланг",
      pickAddModal: "Валюта танланг",
      searchPlaceholder: "Қидириш (USD, доллар...)",
      notFound: "Топилмади",
      rateModalTitle: "Курс —",
      editRateModalTitle: "Курсни таҳрирлаш —",
      editRateTooltip: "Курсни таҳрирлаш", bankRate: "Банк курси:", useBankRate: "Банк курси", bankRateHint: "Ёқилса, курс Марказий банк (CBU) курсидан олинади ва сақлашда янгиланади.", bankRateOn: "Банк курсидан олинмоқда", bankSource: "Марказий банк курси, сана:", bankError: "Банк курсини олишда хатолик (қўлда киритишингиз мумкин).",
      ratePlaceholder: "Масалан: 12700",
      rateHint: "1 {code} неча {base}га тенг эканлигини киритинг",
      cancel: "Бекор",
      save: "Сақлаш",
      saving: "Сақланмоқда...",
      addBtn: "Қўшиш",
      rateInvalid: "Курсни тўғри киритинг",
      baseFirst: "Аввал асосий валютани танланг",
      saved: "Валюта созламалари сақланди",
      error: "Хато юз берди",
      names: {
        UZS: "Ўзбек сўми", USD: "АҚШ доллари", EUR: "Евро", RUB: "Россия рубли",
        KZT: "Қозоғистон тенгеси", GBP: "Британия фунт стерлинги", JPY: "Япония иенаси",
        CNY: "Хитой юани", TRY: "Турк лираси", AED: "БАА дирҳами", KGS: "Қирғизистон соми",
        TJS: "Тожикистон сомонийси", TMT: "Туркманистон манати", AZN: "Озарбайжон манати",
        GEL: "Грузия лариси", UAH: "Украина гривнаси", BYN: "Беларус рубли",
        SAR: "Саудия Арабистони риёли", CAD: "Канада доллари", AUD: "Австралия доллари",
        CHF: "Швейцария франки", INR: "Ҳиндистон рупияси", KRW: "Жанубий Корея вони",
        SEK: "Швеция кронаси", NOK: "Норвегия кронаси", DKK: "Дания кронаси",
        PLN: "Польша злотийи", CZK: "Чехия кронаси", HUF: "Венгрия форинти", RON: "Руминия лейи",
      },
    },
    general: {
      saved: "Сақланди",
      error: "Хато",
      soonBadge: "(тез орада)",
      businessTitle: "Бизнес тури",
      businessSubtitle: "Қайси модуллар ташкилотингиз учун кераклигини танланг — сидебар шу асосда тозаланади",
      businessNote: "Режим фақат UI'га таъсир қилади — маълумотлар ҳар доим сақланиб қолади. Модулни қайтадан кўрсатиш учун \"Ҳаммаси\"ни танланг.",
      skladTitle: "Склад", paymentsTitle: "Тўловлар", paymentsSubtitle: "Пул кирим/чиқим ҳужжатлари созламалари.", paymentStatusesTitle: "Тўлов ҳолатлари", paymentStatusesHint: "Ёқилса, пул кирими ва чиқимида ҳолат (статус) майдони кўринади — ҳолат қўшиш/ўчириш мумкин. Ўчиқ бўлса, статус майдони яширилади.", purchasesTitle: "Харидлар", purchasesSubtitle: "Харид ҳужжатлари созламалари.", purchaseReturnsTitle: "Харид қайтариш (возврат)", salesTitle: "Сотув бўлимлари", salesSubtitle: "Сотувлар менюсида қайси пастки бўлимлар кўринишини танланг.", salesOrders: "Буюртмалар", salesInvoices: "Сотувлар (фактура)", salesReturns: "Қайтаришлар", salesSectionsHint: "Ўчирилган бўлим сидебардан яширилади. Ҳаммаси ўчса — Сотувлар гуруҳи умуман кўринмайди.", salesProductFolder: "Маҳсулот папкаси", salesProductFolderHint: "Сотув формасида фақат шу папкадаги (ва ички папкалардаги) маҳсулотлар кўринади. Бўш = ҳаммаси.", purchaseReturnsHint: "Ёқилса, Харидлар бўлимида «Қайтаришлар» кўринади. Ўчиқ бўлса — яширилади.", discountFieldTitle: "Чегирма майдони", discountFieldHint: "Ёқилса, кирим ва сотув фактураларида чегирма (%) устуни кўринади. Ўчиқ бўлса (default) — яширилади.", purchaseDefaultWarehouse: "Стандарт омбор", purchaseDefaultWarehouseHint: "Кирим ҳужжатлари яратилганда автоматик танланадиган омбор. Бўш = танланмаган.", productionDefaultWarehouses: "Стандарт омборлар", productionDefaultWarehousesHint: "Ишлаб чиқариш ҳужжати яратилганда автоматик танланадиган омборлар.", productionDefaultRawWarehouse: "Хомашё омбори", productionDefaultFinishedWarehouse: "Тайёр маҳсулот омбори", jobProcLaborTitle: "Жараёнда иш ҳақи", jobProcLaborHint: "Заказ жараёнида иш ҳақи (меҳнат) майдони кўринади. Ўчиқ бўлса — яширилади.", jobProcAllocatedTitle: "Жараёнга ажратилган сумма", jobProcAllocatedHint: "Заказ жараёнида ажратилган сумма майдони кўринади. Ўчиқ бўлса — яширилади.", sketchRequiredTitle: "Эскиз мажбурий", sketchRequiredHint: "Ёқилса, заказ яратишда эскиз (расм/PDF) юклаш шарт бўлади. Ўчиқ бўлса (default) — ихтиёрий.", sketchInListTitle: "Заказлар рўйхатида эскиз", sketchInListHint: "Ёқилса, заказлар рўйхатида (# дан кейин) 1-расм (эскиз) кўринади — лупани боссангиз тўлиқ очилади. Расм бўлмаса бўш квадрат. Дефолт ўчиқ.", costWarnTitle: "Таннарх огоҳлантириш фоизи", costWarnHint: "Заказ таннархи келишилган нархнинг шу фоизидан ошса, рўйхатда қизил огоҳлантириш чиқади (жараёнда ва якунланган заказларда). Масалан 50% — таннарх нархнинг ярмидан ошса. Default 50%.", ndsTitle: "Солиқ (ҚҚС)", ndsSubtitle: "Тaшкилот ҚҚС тўловчи бўлса ёқинг — сотув фактураларида ҚҚС устунлари пайдо бўлади.", hasNdsTitle: "ҚҚС тўловчи тaшкилот", hasNdsHint: "Ёқилса, сотув фактураларида МКИX код, ҚҚС ставкаси, ҚҚС миқдори ва Жами устунлари кўринади.", negCashboxTitle: "Касса минусга кетсин", negCashboxHint: "Ёқилса, чиқим кассадаги қолдиқдан ошиб, баланс минусга ўтиши мумкин. Ўчиқ бўлса (default) — қолдиқдан ортиқ чиқим қилинмайди.", cashierTitle: "Кассир", cashierSubtitle: "Кассир туридаги ходимларга қайси кассалар кўринади.", cashierNoCashboxes: "Кассалар йўқ.", cashierHint: "Белгиланган кассаларгина кассирга кўринади. Ҳеч бири белгиланмаса — ҳеч қайси.", cashierCpTitle: "Кассир — контрагент папкалари", cashierCpSubtitle: "Кассир приход қилганда қайси папкадаги контрагентлар чиқади.", cashierNoFolders: "Папкалар йўқ.", cashierCpHint: "Белгиланган папкалардаги контрагентларгина кассирга кўринади. Ҳеч бири белгиланмаса — ҳеч қайси.", snabjenistCpTitle: "Снабженист — таъминотчи папкалари", snabjenistCpSubtitle: "Снабженист таъминотчиларини кўрганда қайси папкалар кўринади.", snabjenistCpHint: "Белгиланган папкалардаги контрагентларгина снабженистга кўринади. Ҳеч бири белгиланмаса — ҳаммаси кўринади.", catCpTitle: "Категория \u2014 контрагент папкаси", catCpSubtitle: "Тўловда категория танланганда контрагент рўйхати шу папкага филтрланади.", catCpEmpty: "Категориялар йўқ.", catCpHint: "\"Контрагентсиз\" танланган категорияда (масалан Озиқ-овқат) контрагент сўралмайди.", catCpAll: "Барча контрагентлар", catCpNone: "Контрагентсиз", catCpIncoming: "кирим", catCpOutgoing: "чиқим",
      skladSubtitle: "Сотув ва қолдиқлар бўйича созламалар",
      jobFoldersTitle: "Папкалашни кўрсатиш",
      negStockTitle: "Манфий қолдиққа рухсат",
      negStockHint: "Ёқилса, омборда йўқ товарни ҳам сотиш мумкин (қолдиқ минусга кетади). Ўчирилса, етарли товар бўлмаса сотув фактураси блокланади.",
      servSellTitle: "Хизмат сотиш",
      servSellHint: "Ёқилса, Инвенторияда \"+ Хизмат\" тугмаси ва \"Хизмат\" фильтри кўринади — хизмат туридаги позицияларни қўшиш ва сотиш мумкин. Ўчирилса, фақат маҳсулотлар билан ишланади.",
      purchasesTitle: "Харидлар",
      purchasesSubtitle: "Сидебардаги \"Харидлар\" бўлимида қайси пастки меню кўринишини танланг",
      purchasesNote: "Режим фақат UI'га таъсир қилади — мавжуд маълумотлар сақланиб қолади.",
      costingTitle: "Таннарх ҳисоби (COGS)",
      costingSubtitle: "Фойда ва омбор қиймати қайси усулда ҳисобланади",
      costingNote: "Эслатма: сотув пайтида таннарх \"музлатиб\" ёзилади — усулни ўзгартирсангиз, эски ҳужжатлар фойдаси ўзгармайди.",
      cpSectionTitle: "Контрагентлар", cpStatusTitle: "Контрагент статуси", cpStatusHint: "Контрагентларда статус (ҳолат) майдони ишлатилади. Ўчиқ бўлса — ҳолат устуни/фильтри/майдони яширилади.", cpFolderTitle: "Контрагент фильтри", cpFolderSubtitle: "Формаларда контрагентларни папка бўйича фильтрлаш",
      cpFolderAll: "Ҳаммаси (фильтрланмасин)",
      cpSupplierFolder: "Харид / Снабжения папкаси", cpSupplierFolderHint: "Харид ва снабжения формаларида фақат шу папкадаги таъминотчилар чиқади",
      cpCustomerFolder: "Сотув / Заказ папкаси", cpCustomerFolderHint: "Сотув ва заказ формаларида фақат шу папкадаги мижозлар чиқади",
      cpFolderNone: "Папкасиз",
      cpJobOrderNewCustomerFolder: "Заказ ичида янги мижоз папкаси", cpJobOrderNewCustomerFolderHint: "Заказ яратишда ичидан қўшилган янги мижоз шу папкага тушади", prodFolderTitle: "Ишлаб чиқариш — маҳсулот папкалари", prodFolderSubtitle: "Ишлаб чиқариш формасида хомашё ва тайёр маҳсулот пикерлари шу папкалардан (ички папкалар билан) кўрсатилади.", prodRawFolder: "Хомашё папкаси", prodRawFolderHint: "Ишлаб чиқариш таркибида (хомашё) фақат шу папкадаги маҳсулотлар кўринади. Бўш = ҳаммаси.", prodFinishedFolder: "Тайёр маҳсулот папкаси", prodFinishedFolderHint: "Ишлаб чиқариш чиқишида (тайёр маҳсулот) фақат шу папкадаги маҳсулотлар кўринади. Бўш = ҳаммаси.", prodOutputBatchTitle: "Тайёр маҳсулот партияси ва муддати", prodOutputBatchHint: "Ёқилса — ишлаб чиқаришда тайёр маҳсулотга партия № ва яроқлилик муддати майдонлари кўринади. Дефолт ўчиқ.", navOrderTitle: "Sidebar тартиби", navOrderSubtitle: "Бўлимлар sidebar'да қайси тартибда кўринишини созланг.", navOrderReset: "Асл тартиб",
      costing: {
        average: { label: "Ўртача-вазнли (AVCO)", hint: "Киримлардан ўртача таннарх автоматик ҳисобланади" },
        manual:  { label: "Қўлда (маҳсулот таннархи)", hint: "Маҳсулотга қўлда киритилган таннарх ишлатилади" },
        fifo:    { label: "FIFO (биринчи кирган — биринчи чиқади)", hint: "Қатламли таннарх: энг эски партия биринчи сотилади" },
        batch:   { label: "Партия (лот) бўйича", hint: "Сотувда партия танланади, муддат билан" },
      },
      business: {
        "job-order": { label: "Йиғувчи (заказ)", hint: "Мижоз буюртмаси бўйича ишлайди — тайёр маҳсулот омбор сақланмайди, тўғридан мижозга берилади. Сотув ва Ишлаб чиқариш модуллари яширин." },
        production:  { label: "Ишлаб чиқариш", hint: "Хом ашёдан тайёр маҳсулот ишлаб чиқаради ва сотади. Ишлаб чиқариш бўлими кўринади, Заказ модули яширин." },
      },
      procurement: {
        orders:      { label: "Заявкалар", hint: "Таъминотчига тўғридан-тўғри буюртма (PO) — содда ишлаш модели." },
        procurement: { label: "Снабжения", hint: "Ички таъминот жараёни: снабженист сўрови → омбор кирими. Компания каттароқ жамоа учун." },
        both:        { label: "Иккаласи", hint: "Заявкалар ва Снабжения — иккала пастки меню ҳам кўринади." },
        none:        { label: "Фақат Киримлар", hint: "Заявкалар ҳам, Снабжения ҳам яширилади — фақат Киримлар (ва Қайтаришлар)." },
      },
    },
  },

  // Settings → UOM & Company tabs
  settingsExtra: {
    uom: {
      customTitle: "Менинг ўлчов бирликларим",
      customSubtitle: "Сиз қўшган, ўчириш мумкин",
      add: "Қўшиш",
      customEmpty: "Ҳали ўз ўлчов бирлигингиз йўқ",
      thShort: "Қисқа ном",
      thFull: "Тўлиқ ном",
      deleteTitle: "Ўчириш",
      systemTitle: "Тизим ўлчов бирликлари",
      systemSubtitle: "Барча ташкилотларга умумий, ўчириб бўлмайди",
      systemBadge: "Тизим", thVisible: "Кўринади", visibleHint: "Белгиланса — тизимда (форма ва рўйхатларда) кўринади", addDisabled: "Ҳозирча ўчирилган",
      newUnit: "Янги ўлчов бирлиги",
      shortName: "Қисқа ном",
      shortNamePlaceholder: "Масалан: кг, дона, м²",
      shortNameHint: "Маҳсулот картасида кўрсатиладиган қисқа белги",
      fullName: "Тўлиқ ном",
      fullNamePlaceholder: "Масалан: Килограм, Дона, Квадрат метр",
      cancel: "Бекор",
      saving: "Сақланмоқда...",
      addBtn: "Қўшиш",
      added: "Ўлчов бирлиги қўшилди",
      deleted: "Ўлчов бирлиги ўчирилди",
      loadError: "Ўлчов бирликларини юклаб бўлмади",
      error: "Хато юз берди",
      groups: {
        count: "Сони",
        weight: "Оғирлик",
        length: "Узунлик",
        areaVol: "Юза ва ҳажм",
        liquid: "Суюқлик",
        packaging: "Қадоқ ва идиш",
        time: "Вақт",
        service: "Хизмат",
        other: "Бошқа",
      },
    },
    trash: {
      retentionLabel: "Сақлаш муддати",
      never: "Ҳеч қачон ўчмасин",
      neverMark: "Ўчмайди",
      retentionSaved: "Муддат сақланди",
      subtitleNever: "ёзувлар ҳеч қачон автоматик ўчмайди. Тикланганда боғлиқ маълумотлар (изоҳлар, ҳаволалар) ҳам қайтарилади.",
      title: "Корзина",
      subtitlePrefix: "Ўчирилган ёзувлар",
      subtitleSuffix: "кундан кейин бутунлай ўчиб кетади. Тикланганда боғлиқ маълумотлар (изоҳлар, ҳаволалар) ҳам қайтарилади.",
      searchPlaceholder: "Номи, телефон...",
      empty: "Корзина бўш",
      thType: "Тури",
      thDetails: "Тафсилот",
      thName: "Номи",
      thDeletedBy: "Ўчирган", allTypes: "Барча турлар", allUsers: "Барча фойдаланувчилар",
      kinds: { Contact: "Контакт", Deal: "Битим", Task: "Вазифа", Funnel: "Воронка" },
      thDate: "Сана",
      thLeft: "Қолди",
      daysSuffix: "кун",
      restoreTitle: "Тиклаш",
      permDeleteTitle: "Бутунлай ўчириш",
      modalTitle: "Бутунлай ўчириш",
      confirmSuffix: "ни бутунлай ўчирасизми? Бу амални қайтариб бўлмайди — ёзув ва бириктирилган файллар ўчиб кетади. Воронка бўлса, унинг битимлари ҳам ўчади.",
      cancel: "Бекор",
      deleting: "Ўчирилмоқда...",
      permDeleteBtn: "Бутунлай ўчириш",
      restored: "Тикланди",
      restoreError: "Тиклашда хато",
      permDeleted: "Бутунлай ўчирилди",
      deleteError: "Ўчиришда хато",
      loadError: "Юклашда хато",
    },
    audit: {
      title: "Аудит журнали",
      subtitle: "Ким, қачон, нима қилгани",
      empty: "Ёзувлар йўқ",
      thTime: "Вақт",
      thUser: "Фойдаланувчи",
      thAction: "Амал",
      thBranch: "Бўлим",
      thObject: "Объект",
      thIp: "IP",
      view: "Кўриш",
      detailTitle: "Ёзув тафсилоти",
      fResource: "Бўлим / ресурс",
      fId: "Объект ID",
      fMethod: "Метод",
      fPath: "Манзил",
      fStatus: "Ҳолат",
      allUsers: "Барча фойдаланувчилар",
      dateFrom: "Санадан",
      dateTo: "Санагача",
      thModule: "Модул",
      modules: { trash: "Корзина", organization: "Созламалар", uom: "Ўлчов бирликлари", inventory: "Маҳсулотлар", counterparty: "Контрагентлар", warehouse: "Омборхоналар", purchases: "Харидлар", sales: "Сотувлар", payments: "Тўловлар", "payment-requests": "Тўлов сўровлари", integrations: "Интеграциялар", cashbox: "Кассалар", conversions: "Конвертация", transfers: "Кўчиришлар", reports: "Ҳисоботлар", upload: "Файллар", trash: "Корзина", export: "Экспорт", production: "Ишлаб чиқариш", departments: "Бўлимлар", branches: "Филиаллар", "job-orders": "Заказлар", proposals: "Таклифлар", "job-order-folders": "Заказ папкалари", contracts: "Шартномалар", "akt-sverka": "Акт-сверка", procurement: "Снабжения",
        contacts: "Контактлар", funnels: "Воронкалар", tasks: "Вазифалар", "lead-forms": "Лид формалар", inbox: "Хабарлар", instagram: "Instagram", facebook: "Facebook", whatsapp: "WhatsApp", atc: "IP-телефония", "lead-journey": "Лид йўли", email: "Email", push: "Push хабарнома", reviews: "Шарҳлар", yandex: "Яндекс",
        "organization-users": "Фойдаланувчилар", "organization-roles": "Роллар", "organization-currencies": "Валюта созламалари", "organization-settings": "Умумий созламалар", "organization-contact-fields": "Контакт майдонлари", "organization-deal-fields": "Битим майдонлари", "organization-task-stages": "Вазифа босқичлари", "organization-deal-sources": "Битим манбалари", "organization-close-reasons": "Ёпиш сабаблари", "organization-goals": "Мақсадлар", "organization-sticker-packs": "Стикер тўпламлари", "organization-telegram-bot": "Telegram бот", "organization-telegram-accounts": "Telegram аккаунт",
        "funnels-deals": "Битимлар", "funnels-deal-activities": "Битим изоҳлари", "funnels-deal-files": "Битим файллари", "contacts-activities": "Контакт изоҳлари" },
      actions: { create: "Яратди", update: "Ўзгартирди", delete: "Ўчирди", login: "Кирди", logout: "Чиқди", register: "Рўйхатдан ўтди", password_change: "Парол ўзгартирди", profile_update: "Профил янгилади" },
      loadError: "Юклашда хато",
    },
    company: {
      subBranches: "Филиаллар",
      subDepartments: "Бўлимлар",
      branches: {
        title: "Филиаллар",
        subtitle: "Ташкилотнинг филиаллари — бўлимларни шу филиалларга бириктириш мумкин",
        add: "Қўшиш",
        empty: "Филиаллар йўқ",
        thName: "Номи",
        thActions: "Амаллар",
        newBranch: "Янги филиал",
        editBranch: "Филиални таҳрирлаш",
        name: "Номи",
        namePlaceholder: "Марказий офис, Чилонзор филиали...",
        nameRequired: "Ном киритилиши шарт",
        cancel: "Бекор",
        save: "Сақлаш",
        deleteTitle: "Филиални ўчириш",
        deleteSuffix: "филиалини ўчирасизми? Шу филиалдаги бўлимлардан филиал боғланиши олиб ташланади (бўлимларнинг ўзи сақланади).",
        deleteBtn: "Ўчириш",
        added: "Қўшилди",
        updated: "Янгиланди",
        deleted: "Ўчирилди",
        loadError: "Юклашда хато",
        error: "Хато",
      },
      departments: {
        title: "Бўлимлар (ишлаб чиқариш жараёнлари)",
        add: "Қўшиш",
        empty: "Бўлимлар йўқ",
        thName: "Номи",
        thBranch: "Филиал",
        thActions: "Амаллар",
        newDept: "Янги бўлим",
        editDept: "Бўлимни таҳрирлаш",
        name: "Номи",
        namePlaceholder: "Кесиш, Бўяш...",
        branch: "Филиал",
        branchNone: "— Танланмаган —",
        thType: "Тури",
        type: "Бўлим тури",
        typeProcess: "Иш жараёнидаги",
        typeManagement: "Бошқарув",
        cancel: "Бекор",
        save: "Сақлаш",
        deleteTitle: "Бўлимни ўчириш",
        deleteSuffix: "бўлимини ўчирасизми? Фойдаланувчилардаги тегишли боғланиш олиб ташланади (лекин фойдаланувчиларнинг ўзлари сақланади).",
        deleteBtn: "Ўчириш",
        added: "Бўлим қўшилди",
        updated: "Янгиланди",
        deleted: "Ўчирилди",
        loadError: "Юклашда хато",
        error: "Хато",
      },
    },
  },

  // Top navbar
  topbar: {
    accountSettings: "Аккаунт созламалари",
    settings: "Созламалар",
    refresh: "Янгилаш",
    lockScreen: "Экранни қулфлаш",
    fullscreen: "Тўлиқ экран",
    exitFullscreen: "Тўлиқ экрандан чиқиш",
    roles: {
      owner: "Эгаси",
      admin: "Админ",
      manager: "Менежер",
      cashier: "Кассир",
      warehouse: "Омборчи",
      viewer: "Кўрувчи",
    },
  },
  assets: {
    pageTitle: "Корхона активлари", pageSubtitle: "Жиҳоз, мебел ва бошқа моддий бойликлар",
    addBtn: "Актив қўшиш", searchPlaceholder: "Номи ёки инвентар ID...",
    statTotal: "Жами активлар", statUnit: "та", statCost: "Дастлабки нарх",
    statAccDep: "Амортизация", statBookValue: "Қолдиқ нарх", currency: "сўм",
    catAll: "Барча категориялар",
    cat_furniture: "Мебел", cat_electronics: "Электр жиҳозлари",
    cat_computer: "Компьютер ва техника", cat_vehicle: "Транспорт",
    cat_equipment: "Ишлаб чиқариш жиҳозлари", cat_office: "Офис жиҳозлари", cat_other: "Бошқа",
    statusAll: "Барча ҳолатлар", statusActive: "Фаол", statusDisposed: "Ҳисобдан чиқарилган",
    status_active: "Фаол", status_disposed: "Ҳисобдан чиқарилган",
    thInventoryId: "Инв. ID", thName: "Номи", thCategory: "Категория",
    thCost: "Дастлабки нарх", thAccDep: "Амортизация", thBookValue: "Қолдиқ нарх",
    thStatus: "Ҳолат", thActions: "Амаллар",
    noItems: "Активлар йўқ",
    deleteConfirm: "Активни ўчирмоқчимисиз?",
    deleteHint: "Барча амортизация ёзувлари ҳам ўчиб кетади.",
    deleteBtn: "Ўчириш", cancel: "Бекор қилиш", deleted: "Актив ўчирилди",
    saved: "Сақланди", created: "Актив қўшилди",
    formTitleNew: "Янги актив", formTitleEdit: "Активни таҳрирлаш",
    saveBtn: "Сақлаш", backBtn: "Орқага",
    sectionMain: "Асосий маълумотлар", sectionFinance: "Молиявий маълумотлар",
    sectionDepreciation: "Амортизация", sectionHistory: "Амортизация тарихи",
    nameLabel: "Номи", namePlaceholder: "Масалан: HP EliteBook 840",
    categoryLabel: "Категория", statusLabel: "Ҳолат",
    descriptionLabel: "Тавсиф", descriptionPlaceholder: "Қўшимча маълумот...",
    locationLabel: "Жойлашув / Бўлим", locationPlaceholder: "Масалан: Молия бўлими",
    responsibleLabel: "Масъул шахс", responsiblePlaceholder: "Ф.И.О.",
    purchaseDateLabel: "Сотиб олинган сана", purchaseCostLabel: "Дастлабки нарх (сўм)",
    disposalDateLabel: "Ҳисобдан чиқариш санаси",
    disposalNoteLabel: "Сабаби", disposalNotePlaceholder: "Эскирди, сотилди...",
    depMethodLabel: "Амортизация усули",
    depMethodNone: "Амортизациясиз", depMethodStraightLine: "Чизиқли усул",
    usefulLifeLabel: "Фойдали хизмат муддати (ой)",
    monthlyDepLabel: "Ойлик амортизация", annualDepLabel: "Йиллик амортизация",
    accDepLabel: "Ҳисобланган амортизация", bookValueLabel: "Қолдиқ (баланс) нархи",
    noteLabel: "Изоҳ", notePlaceholder: "Эслатма...",
    addDepBtn: "Амортизация ёзиш",
    depModalTitle: "Амортизация ёзиш",
    depDateLabel: "Сана", depAmountLabel: "Сумма",
    depNoteLabel: "Изоҳ", depNotePlaceholder: "Масалан: 2026-июн амортизацияси",
    depSaveBtn: "Ёзиш", depAdded: "Амортизация ёзилди", depDeleted: "Ёзув ўчирилди",
    suggestedDep: "Тавсия этилган сумма",
    depAmountRequired: "Сумма киритилиши шарт",
    noDepHistory: "Амортизация ёзувлари йўқ",
    nameRequired: "Номи киритилиши шарт", categoryRequired: "Категория танланиши шарт",
    thDepDate: "Сана", thDepAmount: "Сумма", thDepNote: "Изоҳ",
    catNone: "Категориясиз", catEmpty: "Категориялар йўқ — Созламаларда қўшинг",
    statusNone: "Ҳолатсиз", statusEmpty: "Ҳолатлар йўқ — Созламаларда қўшинг",
    statusAllFilter: "Барча ҳолатлар",
    depMethodStraightLineHint: "Доимий ойлик чегирма",
    monthsSuffix: "ой",
  },
  settingsAssets: {
    tabLabel: "Активлар",
    title: "Активлар созламалари",
    catTitle: "Категориялар",
    catSubtitle: "Активларни гуруҳлаш учун категориялар",
    statusTitle: "Ҳолатлар",
    statusSubtitle: "Ҳар бир активнинг жорий ҳолатини белгилаш учун",
    addCatBtn: "Категория қўшиш",
    addStatusBtn: "Ҳолат қўшиш",
    namePlaceholder: "Номи...",
    colorLabel: "Ранг",
    saveBtn: "Сақлаш",
    cancelBtn: "Бекор қилиш",
    noCats: "Категориялар йўқ",
    noStatuses: "Ҳолатлар йўқ",
    deleted: "Ўчирилди",
    saved: "Сақланди",
    created: "Қўшилди",
    dupError: "Бу ном аллақачон мавжуд",
  },

  // ── CRM-specific pages ─────────────────────────────────────────────────────

  crmDashboard: {
    greeting: "Хуш келибсиз, {name}!",
    loadError: "Маълумотлар юкланмади",
    reload: "Қайта юклаш",
    kpiCalls: "Бугунги қўнғироқлар",
    kpiContacts: "Янги контактлар",
    kpiDeals: "Очиқ битимлар",
    kpiUnanswered: "Жавоб кутилмоқда",
    kpiSubToday: "бугун",
    kpiSubTodayAdded: "бугун қўшилган",
    kpiSubTotal: "жами",
    kpiSubUnanswered: "жавоб берилмаган",
    missedTitle: "Ўтказиб юборилган қўнғироқлар",
    missedEmpty: "Ўтказиб юборилган қўнғироқлар йўқ",
    allCalls: "Барча қўнғироқлар →",
    allTasks: "Барча вазифалар →",
    overdueTitle: "Муддати ўтган вазифалар",
    dueDate: "Муддат:",
    activityTitle: "Сўнгги фаолият",
    activityEmpty: "Фаолият йўқ",
    funnelTitle: "Фуннел статистикаси",
    funnelEmpty: "Фуннел йўқ",
    noDeal: "Битим йўқ",
    quickLinks: "Тез ҳаволалар",
    addContact: "Контакт қўшиш",
    callHistory: "Қўнғироқлар тарихи",
    incoming: "Кирувчи",
    outgoing: "Чиқувчи",
  },

  tasks: {
    title: "Вазифалар",
    newTask: "Янги вазифа",
    editTask: "Вазифани таҳрирлаш",
    viewTask: "Вазифани кўриш",
    close: "Ёпиш",
    noStagesTitle: "Вазифалар бўлими",
    noStages: "Ҳали босқичлар созланмаган. Созламалар → Вазифалар бўлимида босқичлар қўшинг.",
    search: "Қидириш...",
    filter: "Фильтр",
    clearFilters: "Тозалаш",
    allPriorities: "Барчаси",
    allAssignees: "Барча ходимлар",
    assignedToMe: "Менга бириктирилган",
    createdByMe: "Мен яратганим",
    overdue: "муддати ўтган",
    totalNote: "Жами {total} та — биринчи {shown} та кўрсатилмоқда",
    deleteConfirm: "Ўчиришни тасдиқлайсизми?",
    prioLow: "Паст",
    prioMedium: "Ўрта",
    prioHigh: "Юқори",
    modalTitle: "Сарлавҳа *",
    titlePlaceholder: "Нима қилиш керак...",
    titleRequired: "Сарлавҳа киритилиши шарт",
    description: "Тавсиф / изоҳ",
    descPlaceholder: "Батафсил тавсиф...",
    priority: "Муҳимлик",
    stage: "Босқич",
    assignee: "Масъул",
    additionalAssignees: "Қўшимча масъуллар",
    unassigned: "Танланмаган",
    dueDate: "Муддат",
    contact: "Контакт",
    contactSearch: "Контакт қидиринг...",
    linked: "Боғланган",
    files: "Файллар",
    uploadFile: "+ Файл юклаш",
    uploading: "Юкланмоқда...",
    tags: "Теглар",
    tagsPlaceholder: "Тег қўшиш, Enter босинг...",
    createdByPrefix: "Қўшди:",
    historyTitle: "Ўзгаришлар тарихи",
    histUnknownUser: "Номаълум",
    histCreated: "вазифани яратди",
    histStageChanged: "босқични ўзгартирди",
    histAssigned: "масъул бириктирди",
    histUnassigned: "масъулни бекор қилди",
    histArchived: "архивлади",
    histUnarchived: "архивдан чиқарди",
    histCompleted: "бажарилди деб белгилади",
    archive: "Архив", archived: "Вазифа архивланди", archiveEmpty: "Архивда вазифа йўқ",
    restore: "Архивдан чиқариш", restored: "Вазифа архивдан чиқарилди",
    assignedToPrefix: "Бириктирилган:",
    cancel: "Бекор",
    save: "Сақлаш",
    create: "Яратиш",
    saved: "Сақланди",
    created: "Яратилди",
    deleted: "Ўчирилди",
    loadError: "Юкланишда хато",
    error: "Хато",
    viewKanban: "Канбан",
    viewDue: "Муддат",
    viewCalendar: "Календар",
    viewDay: "Кун",
    viewWeek: "Ҳафта",
    viewMonth: "Ой",
    noDateBucket: "Санасиз",
    colOverdue: "Муддати ўтган",
    colToday: "Бугунги",
    colTomorrow: "Эртанги",
    colThisWeek: "Бу ҳафта",
    colNextWeek: "Кейинги ҳафта",
    completeTitle: "Вазифани якунлаш",
    outcomeNotePlaceholder: "Натижа: нима гаплашилди, келишув...",
    logToDeal: "Сделка тарихига ёзиш",
    createFollowUp: "Кейинги вазифа яратиш",
    followUpTitle: "Кейинги вазифа сарлавҳаси",
    followUpDue: "Кейинги вазифа муддати",
    followUpAssignee: "Масъул (ихтиёрий)",
    completeConfirm: "Якунлаш",
    completeSuccess: "Вазифа якунланди",
    markDone: "Бажардим",
    noDoneStage: "«Бажарилди» босқичи созланмаган",
    doneBadge: "Бажарилди",
  },

  calls: {
    title: "Қўнғироқлар",
    all: "Барчаси",
    incoming: "Кирувчи",
    outgoing: "Чиқувчи",
    missed: "Ўтказиб юборилган",
    completed: "Бажарилган",
    ringing: "Жиринглаяпти",
    busy: "Банд",
    search: "Телефон ёки контакт...",
    dateFrom: "Дан",
    dateTo: "Гача",
    noResults: "Қўнғироқлар топилмади",
    emptyHint: "Биринчи қўнғироқлар бу ерда кўринади",
    deleteSelected: "Танланганларни ўчириш",
    selectAll: "Ҳаммасини танлаш",
    deselectAll: "Ҳаммасини бекор қилиш",
    deleteConfirm: "Танланган {n} та қўнғироқ ўчирилсинми?",
    deleted: "Ўчирилди",
    loadError: "Юкланишда хато",
    thDate: "Сана / вақт",
    thDirection: "Йўналиш",
    thPhone: "Телефон",
    thContact: "Контакт",
    thDuration: "Давомийлиги",
    thStatus: "Ҳолат",
    thRecord: "Ёзув",
    thExt: "Телефон рақам",
    statsTotal: "Жами",
    statsMissed: "Ўтказилган",
    statsDuration: "Умумий вақт",
    linkContact: "Боғлаш",
    linked: "Боғланган",
    viewContact: "Контактга ўтиш",
    analytics: "Аналитика",
    noContact: "Контактсиз",
    unknown: "Номаълум",
  },

  contacts: {
    title: "Контактлар",
    reminderOverdue: "Эслатма муддати ўтди",
    newContact: "Янги контакт",
    search: "Исм, телефон, email...",
    noContacts: "Контактлар топилмади",
    emptyHint: "Биринчи контактингизни қўшинг",
    import: "Импорт",
    export: "Экспорт",
    columns: "Устунлар",
    deleteSelected: "Ўчириш ({n})",
    deleteConfirm: "Танланган {n} та контакт ўчирилсинми?",
    deleted: "Ўчирилди",
    loadError: "Юкланишда хато",
    importTitle: "CSV импорт",
    importHint: "CSV файл юкланг. Биринчи қатор — устун номлари.",
    importBtn: "Юклаш",
    importPreview: "Кўриниш",
    importSave: "Сақлаш",
    importCancel: "Бекор",
    importSuccess: "{n} та контакт қўшилди",
    importError: "Импорт хатоси",
    exportSuccess: "Экспорт бошланди",
    selectFile: "CSV файлни танланг",
    mapping: "Устунларни боғлаш",
    analytics: "Аналитика",
    thName: "Исм",
    thPhone: "Телефон",
    thEmail: "Email",
    thSource: "Манба",
    thCreated: "Сана",
    thActions: "Амаллар",
    filterSource: "Манба бўйича",
    allSources: "Барча манбалар",
    yes: "Ҳа",
    no: "Йўқ",
    fileAttached: "📎 Файл",
    columnsTitle: "Устунларни танлаш",
  },

  contactForm: {
    newTitle: "Янги контакт",
    editTitle: "Контактни таҳрирлаш",
    back: "Орқага",
    save: "Сақлаш",
    saving: "Сақланмоқда...",
    delete: "Ўчириш",
    deleteConfirm: "Контакт ўчирилсинми?",
    deleted: "Ўчирилди",
    saved: "Сақланди",
    created: "Яратилди",
    loadError: "Юкланишда хато",
    tabGeneral: "Асосий",
    tabActivity: "Фаолият тарихи",
    tabDeals: "Битимлар",
    name: "Исм *",
    namePlaceholder: "Тўлиқ исм...",
    nameRequired: "Исм киритилиши шарт",
    phone: "Телефон",
    phonePlaceholder: "+998 XX XXX XX XX",
    email: "Email",
    emailPlaceholder: "example@mail.com",
    source: "Манба",
    sourcePlaceholder: "Telegram, website...",
    notes: "Изоҳлар",
    notesPlaceholder: "Эслатмалар...",
    activityEmpty: "Фаолият йўқ",
    activityCall: "Қўнғироқ",
    activityNote: "Эслатма",
    dealsEmpty: "Битимлар йўқ",
    dealAdd: "Битим қўшиш",
    error: "Хато юз берди",
    cancel: "Бекор",
    blocked: "Блокланган",
    reminder: "Эслатма",
    reminderOverdue: "Эслатма муддати ўтди",
    block: "Блоклаш",
    unblock: "Блокдан чиқариш",
    tabFiles: "Файллар",
    tabSettings: "Созлама",
    activitySub: "Изоҳлар, қўнғироқлар ва ўзгаришлар",
    activityHint: "Контакт сақланганидан кейин изоҳ қўша оласиз",
    activityEmptyHint: "Биринчи изоҳни ёзинг",
  },

  inbox: {
    title: "Inbox",
    search: "Қидириш...",
    tabUnanswered: "Жавоб берилмаган",
    tabAccepted: "Қабул қилинган",
    tabClosed: "Ёпилган",
    noUnanswered: "Жавоб берилмаган хабар йўқ",
    noUnansweredHint: "Янги хабарлар бу ерда кўринади",
    noClosed: "Ёпилган чат йўқ",
    noClosedHint: "Ёпилган суҳбатлар бу ерда кўринади",
    noAccepted: "Қабул қилинган чат йўқ",
    noConvsTotal: "Суҳбатлар йўқ",
    selectConv: "Суҳбат танланг",
    selectConvHint: "Чап томондаги рўйхатдан суҳбатни очинг",
    convCount: "{n} та суҳбат",
    sendPlaceholder: "Хабар ёзинг...",
    emailPlaceholder: "Email жавобини ёзинг...",
    notePlaceholder: "Ички эслатма ёзинг...",
    noteMode: "Ички эслатма режими — фақат жамоа учун кўринади",
    deleteConv: "Суҳбатни ўчириш",
    deleteMsg: "Хабарни ўчириш",
    markAnswered: "Жавоб берилди деб белгилаш",
    markUnanswered: "Жавоб берилмаган деб белгилаш",
    closeConv: "Суҳбатни ёпиш",
    openConv: "Суҳбатни очиш",
    reassign: "Тайинлаш",
    reassignTitle: "Ходимга тайинлаш",
    reassignNone: "Тайинсиз",
    labelTitle: "Ёрлиқ",
    addLabel: "Ёрлиқ қўшиш...",
    convInfo: "Маълумот",
    goToContact: "Контактга ўтиш",
    createContact: "Контакт яратиш",
    loadError: "Юкланишда хато",
    sendError: "Юборишда хато",
    deleteError: "Ўчиришда хато",
    analytics: "Аналитика",
    back: "Орқага",
    noSubject: "(Мавзу йўқ)",
    from: "Ким:",
    to: "Кимга:",
    noAcceptedHint: "Очилган чатлар бу ерга ўтади",
    delete: "Ўчириш",
    msgNotFound: "Хабар топилмади",
    noMsgs: "Хабарлар йўқ",
    captionPlaceholder: "Изоҳ қўшинг (ихтиёрий)...",
    allConvs: "Барча суҳбатлар",
    assignedAgent: "Масъул агент",
    linkedContact: "Боғланган контакт",
    contactName: "Исм *",
    cancel: "Бекор",
    save: "Сақлаш",
    noData: "Маълумот топилмади",
  },

  dashboardHome: {
    dateLocale: "uz-Cyrl-UZ",
    loadError: "Маълумот юкланмади", retry: "Қайта уриниш",
    overdueLabel: "Муддати ўтган", overdueSubAlert: "Дарҳол эътибор керак", overdueSubOk: "Ҳаммаси вақтида",
    completedLabel: "Бажарилган", completedSub: "Охирги босқичдаги",
    activeLabel: "Фаол вазифалар", activeSub: "Бажарилиши керак",
    unassignedLabel: "Бириктирилмаган", unassignedSubNoLeads: "Белгиланмаган лидлар",
    goalsTitle: "Мақсадлар", gaugeSum: "Сумма", gaugeDealCount: "Савдолар сони",
    byEmployee: "Ходимлар бўйича", donutSum: "Сумма", donutCount: "Сони",
    byManager: "Менежерлар бўйича", dealsCountLabel: "Савдолар", sumLabel: "Сумма",
    dealSources: "Савдолар манбаи", other: "Бошқа", total: "Жами", unit: "та",
  },

  funnel: {
    journeyAnalytics: "Лидлар йўли",
    newDeal: "Янги битим",
    addQuick: "Тез қўшиш",
    dealSearch: "Сделка, контакт исми ёки рақам...",
    sortLabel: 'Саралаш',
    sortManual: "Одатий (қўлда тартибланган)",
    sortCreatedAsc: "Эски - янги (яратилгани бўйича)",
    sortCreatedDesc: "Янги - эски (яратилгани бўйича)",
    sortUpdatedAsc: "Эски - янги (статуси ўзгаргани бўйича)",
    sortUpdatedDesc: "Янги - эски (статуси ўзгаргани бўйича)",
    sortTitleAsc: 'A - Z',
    sortTitleDesc: 'Z - A',
    dateFrom: 'Яратилган сана — дан',
    dateTo: 'Яратилган сана — гача',
    showClosed: 'Ёпилганлар',
    bulkSelectTitle: 'Оммавий танлаш',
    select: 'Танлаш',
    selectCancel: 'Бекор қилиш',
    archiveBtn: 'Архив',
    statsBtn: 'Статистика',
    noDeals: "Битим йўқ",
    totalDeals: "та битим",
    totalValue: "жами қиймат",
    loadError: "Юкланишда хато",
    deleteConfirm: "Битим ўчирилсинми?",
    deleted: "Ўчирилди",
    edit: "Таҳрирлаш",
    newLead: "Янги заявка",
    leadNameLabel: "Мижоз исми *",
    contactOpt: "Контакт (ихтиёрий)",
    noContact: "— Контактсиз",
    createContact: "+ Янги контакт яратиш",
    contactNamePh: "Исм *",
    contactPhonePh: "Телефон",
    contactEmailPh: "Email",
    contactCreated: "Контакт яратилди",
    contactExists: "Бундай контакт аллақачон мавжуд",
    responsibleLabel: "Масъул ходим",
    unassigned: "— Танланмаган",
    notesPlaceholder: "Қўшимча маълумот...",
    addBtn: "Қўшиш",
    titleRequired: "Сарлавҳа киритилиши шарт",
    searchPlaceholder: "Қидириш...",
    noFunnel: "Варонка топилмади",
    stagePlaceholder: "Босқич номи...",
    moveTitle: "Битим қиймати",
    moveHint: "Суммани киритинг (ихтиёрий)",
    moveSave: "Кўчириш",
    moveCancel: "Бекор",
    export: "Экспорт",
    import: "Импорт",
    exportDone: "Excel юклаб олинди",
    exportError: "Экспорт хатоси",
    importTitle: "Excel импорт",
    importDone: "Импорт тугади!",
    importCreated: "та лид қўшилди",
    importSkipped: "та ўтказиб юборилди",
    importFormat: "Excel (.xlsx) устунлари:",
    importHint: "Биринчи қатор — устун номлари. Фақат «Sarlavha» устуни мажбурий.",
    downloadTemplate: "Шаблонни юклаб олиш",
    templateError: "Шаблонни юклаб бўлмади",
    importBtn: "Импорт қилиш",
    importError: "Импорт хатоси",
    onlyXlsx: "Фақат .xlsx файл қабул қилинади",
    dropXlsx: "Excel (.xlsx) файлни бу ерга ташланг",
    orClick: "ёки босинг ва танланг",
    clear: "Тозалаш",
    cancel: "Бекор",
    close: "Ёпиш",
  },

  deals: {
    back: "Орқага",
    newDeal: "Янги битим",
    editDeal: "Битимни таҳрирлаш",
    save: "Сақлаш",
    cancel: "Бекор",
    delete: "Ўчириш",
    deleteConfirm: "Битим ўчирилсинми?",
    deleted: "Ўчирилди",
    saved: "Сақланди",
    created: "Яратилди",
    loadError: "Юкланишда хато",
    titleLabel: "Сарлавҳа *",
    titlePlaceholder: "Битим номи...",
    titleRequired: "Сарлавҳа киритилиши шарт",
    contact: "Контакт",
    value: "Сумма",
    currency: "Валюта",
    stage: "Босқич",
    moveToFunnel: "Бошқа воронкага ўтказиш",
    moveFunnelLabel: "Воронка",
    moveFunnelPlaceholder: "Воронкани танланг...",
    moveStagePlaceholder: "Босқични танланг...",
    moveReasonLabel: "Сабаб (ихтиёрий)",
    moveReasonPlaceholder: "Нима учун бошқа воронкага ўтказилаяпти...",
    moveSubmit: "Ўтказиш",
    moveSuccess: "Воронкага ўтказилди",
    assignee: "Масъул",
    dueDate: "Муддат",
    notes: "Изоҳ",
    notesPlaceholder: "Изоҳ...",
    wonTitle: "Битим ютилди",
    lostTitle: "Битим йўқотилди",
    wonReason: "Сабаб ёки изоҳ (ихтиёрий)",
    lostReason: "Йўқотиш сабаби (ихтиёрий)",
    reasonPlaceholder: "Сабаб...",
    confirm: "Тасдиқлаш",
    activitySub: "Изоҳлар ва ўзгаришлар",
    notePlaceholder: "Изоҳ ёзинг...",
    activityEmpty: "Фаолият йўқ",
    activityHint: "Биринчи изоҳни ёзинг",
    noteTab: "Изоҳ",
    communicationTab: "Контакт",
    contactTypeCall: "Қўнғироқ",
    contactTypeMessage: "Хабар",
    contactTypeMeeting: "Учрашув",
    durationLabel: "дақиқа",
    outcomeInterested: "Қизиқди",
    outcomeThinking: "Ўйлаяпти",
    outcomeDeclined: "Рад этди",
    outcomeNoAnswer: "Жавоб бермади",
    outcomeOther: "Бошқа",
  },

  inboxAnalytics: {
    title: "Inbox Аналитикаси",
    back: "Inbox",
    tabGeneral: "Умумий",
    tabAgents: "Ходимлар",
    preset7d: "7 кун",
    presetMonth: "Бу ой",
    presetPrevMonth: "Ўтган ой",
    presetQuarter: "Бу чорак",
    presetCustom: "Махсус",
    apply: "Қўллаш",
    compare: "Олдинги давр билан солиштир",
    totalConvs: "Жами суҳбатлар",
    unanswered: "Жавоб берилмаган",
    closed: "Ёпилган",
    avgResponse: "Ўрт. жавоб вақти",
    firstResponse: "Биринчи жавоб",
    resolutionRate: "Ҳал қилиш:",
    prevPeriod: "ўтган давр:",
    dailyChart: "Кунлик суҳбатлар",
    dayCount: "кун",
    comparison: "Давр солиштирувчи",
    total: "Жами",
    closedPct: "Ҳал қилиш %",
    byChannel: "Каналлар бўйича",
    agentStats: "Агентлар",
    labelStats: "Ёрлиқлар",
    noData: "Маълумот йўқ",
    noLabels: "Ёрлиқ йўқ",
    agentReport: "Ходимлар бўйича ҳисобот",
    exportCsv: "CSV юклаб олиш",
    thAgent: "Ходим",
    thTotal: "Суҳбатлар",
    thClosed: "Ёпилган",
    thClosedPct: "Ёпиш %",
    thAvgResp: "Ўрт. жавоб",
    thCalls: "Қўнғироқ",
    loadError: "Юкланмади",
  },

  contactAnalytics: {
    title: "Контактлар Аналитикаси",
    back: "Контактлар",
    preset30d: "30 кун",
    presetMonth: "Бу ой",
    preset90d: "90 кун",
    presetCustom: "Махсус",
    apply: "Қўллаш",
    periodNew: "Давр учун янги контактлар",
    totalAll: "Жами контактлар",
    allTime: "Барча вақт учун",
    dailyChart: "Кунлик янги контактлар",
    byChannel: "Канал бўйича (Inbox орқали)",
    byOperator: "Оператор бўйича",
    noPhone: "Телефон рақамлар йўқ",
    noData: "Маълумот йўқ",
    loadError: "Юкланмади",
  },

  leadJourney: {
    title: "Лидлар йўли",
    back: "Воронкалар",
    preset30d: "30 кун",
    presetMonth: "Бу ой",
    preset90d: "90 кун",
    presetCustom: "Махсус",
    apply: "Қўллаш",
    contactsWidgetTitle: "Бугунги/даврдаги контактлар",
    uniqueLeadsContacted: "нойоб лид билан алоқа бўлди",
    byType: "Тури бўйича",
    interactedTitle: "Алоқа бўлган мижозлар",
    calledTitle: "Гаплашилган мижозлар",
    calledHint: "Қўнғироқ қилиб гаплашилган",
    sourceFunnelChange: "Воронка ўтказиш",
    sourceStageChange: "Босқич ўтказиш",
    sourceComment: "Изоҳ қолдириш",
    sourceInbox: "Хабар (Telegram ва ҳ.к.)",
    transitionsWidgetTitle: "Воронкалараро ўтишлар",
    transitionsEmpty: "Бу даврда воронкалараро ўтиш бўлмаган",
    snapshotWidgetTitle: "Жорий ҳолат — воронка/босқич бўйича",
    loadError: "Юкланмади",
  },

  bottomNav: {
    dashboard: "Бош",
    contacts: "Контактлар",
    tasks: "Вазифалар",
    inbox: "Inbox",
    calls: "Қўнғироқлар",
    reviews: "Отзивлар",
    funnels: "Воронкалар",
  },
};
